import { useEffect, useState, useRef } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Select from "react-select";
import { useNavigate } from "react-router-dom";

import NewBroker from '../models/NewBroker';



function AddSale2() {
    const dropdownRef = useRef(null);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    const formatVisitDate = (dateStr) => {
        if (!dateStr) return '';
        try {
            const d = new Date(dateStr);
            if (isNaN(d.getTime())) return dateStr;
            const dd = String(d.getDate()).padStart(2, '0');
            const month = monthNames[d.getMonth()];
            const year = d.getFullYear();
            let hh = d.getHours();
            const mm = String(d.getMinutes()).padStart(2, '0');
            const ampm = hh >= 12 ? 'PM' : 'AM';
            hh = hh % 12 || 12;
            return `${dd}-${month}-${year} ${String(hh).padStart(2, '0')}:${mm} ${ampm}`;
        } catch (e) {
            return dateStr;
        }
    };
    const [showBrokerModal, setShowBrokerModal] = useState(false);
    const [ldata, setLdata] = useState(null);
    const otDocRef = useRef();
    const referralDocRef = useRef();
    const [searchTerm, setSearchTerm] = useState('');
    const [showReferralDropdown, setShowReferralDropdown] = useState(false);
    const [showReferralDoctorDropdown, setShowReferralDoctorDropdown] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [isUHIDReadOnly, setIsUHIDReadOnly] = useState(false);
    const [originalLabRegType, setOriginalLabRegType] = useState("");
    const [medicineSearch, setMedicineSearch] = useState("");
    const [showMedicineOptions, setShowMedicineOptions] = useState(false);
    const [image, setImage] = useState('');
    const [expiringMedicines, setExpiringMedicines] = useState([]);
    const [showExpiryAlert, setShowExpiryAlert] = useState(false);
    const [brokers, setBrokers] = useState([]);
    const [selectedBroker, setSelectedBroker] = useState(null);
    const [brokerCommission, setBrokerCommission] = useState(0);
    const navigate = useNavigate();
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentMode, setPaymentMode] = useState('');
    const [paymentAmount, setPaymentAmount] = useState('');
    const [paymentReceivedBy, setPaymentReceivedBy] = useState('');
    const [paymentRemarks, setPaymentRemarks] = useState('');
    const [paymentHistory, setPaymentHistory] = useState([]);
    const [selectedPaymentBill, setSelectedPaymentBill] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [discountType, setDiscountType] = useState('percentage');

    const [originalRecord, setOriginalRecord] = useState(null);
// ── NEW: phone search states ──

const [pharmaSearchMode, setPharmaSearchMode] = useState('phone');
const [pharmaPhoneSearch, setPharmaPhoneSearch]       = useState('');
const [pharmaPatientResults, setPharmaPatientResults] = useState([]);
const [showPharmaPatientModal, setShowPharmaPatientModal] = useState(false);
const [pharmaSearchLoading, setPharmaSearchLoading]   = useState(false);

const [pharmaSearchInput, setPharmaSearchInput] = useState('');
const [pharmaSuggestions, setPharmaSuggestions] = useState([]);
const pharmaSearchDebounceRef = useRef(null);


    // ✅ KEYBOARD NAVIGATION REFS AND STATE
    const medicineSearchRef = useRef(null);
    const tableRowRefs = useRef([]);
    const [selectedDropdownIndex, setSelectedDropdownIndex] = useState(-1);
    const [filteredMedicines, setFilteredMedicines] = useState([]);


    const [activeCell, setActiveCell] = useState(null); // {rowIndex, cellName}
    const [formData, setFormData] = useState({
        medicines: [
            {
                sn: 1,
                med_bill_item_medicine: '',
                med_bill_item_batch: '',
                med_bill_item_qty: '',
                med_bill_item_strips: '',
                med_bill_item_is_loose: '',
                med_bill_item_exp: '',
                med_bill_item_mrp: '',
                med_bill_item_discount: '',
                med_bill_item_discount_amt: '',
                med_bill_item_tax: '',
                med_bill_item_tax_amt: '',
                med_bill_item_total: '',

                med_bill_broker_id: '',
med_bill_broker_name: '',
med_bill_broker_commission: '0',
med_bill_broker_commission_type: 'fixed',
            }
        ],
        medicineList:[],
        med_bill_id: '',
        med_bill_date: '',
        med_bill_type:'normal',
        med_bill_ipd_number: '',
        med_bill_patient_number: '',
        med_bill_doctor: '',
        med_bill_ref_doctor: '',
        med_bill_phone_number: '',
        med_bill_address_of_patient: '',
        med_bill_gst_number: '',
        med_bill_drug_licence_no: '',
        med_bill_discount: '',
        med_bill_discount_amt: '',
        med_bill_mode_of_payment: '',
        med_bill_total: '',
        med_bill_final_amt: '',
        med_bill_paid: '',
        med_bill_payment_mode: '',
        med_bill_remarks: '',
        med_bill_due: '',
        med_bill_user: '',
        total_qty : '',
        docs: [],
        vitals: [],
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });


    const [medicinePage, setMedicinePage] = useState(0); // ✅ NEW: pagination state
    const MEDICINES_PER_PAGE = 5;
    
    useEffect(() => {
        // ✅ Reset page to 0 whenever search changes
        setMedicinePage(0);
    }, [medicineSearch]);
    



    useEffect(() => {
        if (!selectedBroker) {
          setBrokerCommission(0);
          setFormData(prev => ({
            ...prev,
            med_bill_broker_id: '',
            med_bill_broker_name: '',
            med_bill_broker_commission: '0',
            med_bill_broker_commission_type: 'fixed'
          }));
          return;
        }
      
        const finalAmt = parseFloat(formData.grand_total || 0);
        const type = (selectedBroker.pharmacy_commission_type || 'fixed').toLowerCase();
        const val  = parseFloat(selectedBroker.pharmacy_commission || 0);
      
        let commission = 0;
        if (val > 0 && finalAmt > 0) {
          commission = (type === 'percentage' || type === 'percent' || type === '%')
            ? (finalAmt * val) / 100
            : val;
        }
      
        setBrokerCommission(commission);
        setFormData(prev => ({
          ...prev,
          med_bill_broker_id: selectedBroker.id || selectedBroker.broker_id || '',
          med_bill_broker_name: `${selectedBroker.fname || ''} ${selectedBroker.lname || ''}`.trim(),
          med_bill_broker_commission: commission.toFixed(2),
          med_bill_broker_commission_type: type
        }));
      }, [selectedBroker, formData.grand_total]);


    useEffect(() => {
        if (formData.medicineList && formData.medicineList.length > 0) {
            const searchKey = (medicineSearch || '').toLowerCase().trim();
    
            let filtered;
            if (searchKey) {
                // ✅ STEP 1: Direct match — name, batch, composition, purpose
                filtered = formData.medicineList.filter(m =>
                    (m.purchase_item_medicine || '').toLowerCase().includes(searchKey) ||
                    (m.purchase_item_batch || '').toLowerCase().includes(searchKey) ||
                    (m.med_composition || '').toLowerCase().includes(searchKey) ||
                    (m.med_comp_name || '').toLowerCase().includes(searchKey) ||
                    (m.purpose_name || '').toLowerCase().includes(searchKey)
                );
    
                // ✅ STEP 1b: Composition cross-match
                const matchedCompositions = new Set();
                filtered.forEach(m => {
                    const comp = (m.med_composition || '').toLowerCase().trim();
                    if (comp) matchedCompositions.add(comp);
                });
    
                formData.medicineList.forEach(m => {
                    const comp = (m.med_composition || '').toLowerCase();
                    if (comp && comp.includes(searchKey)) {
                        matchedCompositions.add(comp);
                    }
                });
    
                if (matchedCompositions.size > 0) {
                    const existingIds = new Set(filtered.map(m => m.purchase_item_id));
                    formData.medicineList.forEach(m => {
                        if (existingIds.has(m.purchase_item_id)) return;
                        const comp = (m.med_composition || '').toLowerCase().trim();
                        if (comp && matchedCompositions.has(comp)) {
                            filtered.push(m);
                        }
                    });
                }
            } else {
                // ✅ No search — show ALL medicines (paginated, so safe)
                filtered = formData.medicineList;
            }
    
            // ✅ STEP 2: Combine SAME medicine + SAME batch
            const batchCombined = {};
            filtered.forEach(m => {
                const key = `${m.purchase_item_medicine}|||${m.purchase_item_batch}`;
                if (!batchCombined[key]) {
                    batchCombined[key] = {
                        ...m,
                        _total_pkg_stock: parseInt(m.purchase_item_qty_stock || 0),
                        _total_loose_stock: parseInt(m.purchase_item_tab_cap_stock || 0),
                        _source_rows: [m]
                    };
                } else {
                    batchCombined[key]._total_pkg_stock += parseInt(m.purchase_item_qty_stock || 0);
                    batchCombined[key]._total_loose_stock += parseInt(m.purchase_item_tab_cap_stock || 0);
                    batchCombined[key]._source_rows.push(m);
    
                    const currentPkg = parseInt(batchCombined[key].purchase_item_qty_stock || 0);
                    const currentLoose = parseInt(batchCombined[key].purchase_item_tab_cap_stock || 0);
                    const newPkg = parseInt(m.purchase_item_qty_stock || 0);
                    const newLoose = parseInt(m.purchase_item_tab_cap_stock || 0);
    
                    if ((newPkg + newLoose) > (currentPkg + currentLoose)) {
                        const saved = {
                            _total_pkg_stock: batchCombined[key]._total_pkg_stock,
                            _total_loose_stock: batchCombined[key]._total_loose_stock,
                            _source_rows: batchCombined[key]._source_rows
                        };
                        batchCombined[key] = { ...m, ...saved };
                    }
                }
            });
    
            Object.values(batchCombined).forEach(item => {
                item.purchase_item_qty_stock = item._total_pkg_stock;
                item.purchase_item_tab_cap_stock = item._total_loose_stock;
            });
    
            const combinedList = Object.values(batchCombined);
    
            // ✅ STEP 3: Group by medicine name
            const medicineGroups = combinedList.reduce((acc, m) => {
                if (!acc[m.purchase_item_medicine]) {
                    acc[m.purchase_item_medicine] = {
                        ...m,
                        batches: [],
                        total_stock: 0
                    };
                }
    
                const pkgStock = parseInt(m.purchase_item_qty_stock || 0);
                const looseStock = parseInt(m.purchase_item_tab_cap_stock || 0);
                const combinedStock = pkgStock + looseStock;
    
                if (combinedStock > 0) {
                    acc[m.purchase_item_medicine].batches.push(m);
                    acc[m.purchase_item_medicine].total_stock += combinedStock;
                }
    
                return acc;
            }, {});
    
            const available = Object.values(medicineGroups)
                .filter(group => group.total_stock > 0);
    
            setFilteredMedicines(available);
            setSelectedDropdownIndex(available.length > 0 ? 0 : -1);
        } else {
            setFilteredMedicines([]);
            setSelectedDropdownIndex(-1);
        }
    }, [medicineSearch, formData.medicineList]);

    const handleMedicineSearchKeyDown = (e) => {
    // Enter key handling
    if (e.key === 'Enter') {
        e.preventDefault();
        
        // Case 1: Dropdown is open with a selected item - SELECT IT
        if (showMedicineOptions && selectedDropdownIndex >= 0 && filteredMedicines.length > 0 && filteredMedicines[selectedDropdownIndex]) {
            const selected = filteredMedicines[selectedDropdownIndex];
            
            // ✅ Filter for ANY stock (package OR loose)
            const bestBatch = selected.batches
                .filter(b => {
                    const pkgStock = parseInt(b.purchase_item_qty_stock || 0);
                    const looseStock = parseInt(b.purchase_item_tab_cap_stock || 0);
                    return pkgStock > 0 || looseStock > 0;
                })
                .sort((a, b) => {
                    const expA = `${a.purchase_item_expiry_year}-${String(a.purchase_item_expiry_month).padStart(2, '0')}`;
                    const expB = `${b.purchase_item_expiry_year}-${String(b.purchase_item_expiry_month).padStart(2, '0')}`;
                    return expB.localeCompare(expA);
                })[0];
            
            if (bestBatch) {
                handleMedicineSelect(bestBatch);
                setTimeout(() => {
                    const lastRowIndex = formData.medicines.filter(m => m.med_bill_item_medicine).length - 1;
                    if (tableRowRefs.current[lastRowIndex]) {
                        const packSelect = tableRowRefs.current[lastRowIndex].querySelector('select[name^="med_bill_item_is_loose"]');
                        if (packSelect) {
                            packSelect.focus();
                        }
                    }
                }, 100);
            }
            return;
        }
        
        // Case 2: Dropdown is not open OR no item selected - ALWAYS OPEN IT
        // ✅ Force open the dropdown
        setShowMedicineOptions(true);
        
        // ✅ Select first item if available
        if (filteredMedicines.length > 0) {
            setSelectedDropdownIndex(0);
        } else {
            setSelectedDropdownIndex(-1);
        }
        return;
    }

    // Arrow Down - Navigate dropdown
   // Arrow Down - Navigate dropdown
if (e.key === 'ArrowDown') {
    e.preventDefault();
    
    if (!showMedicineOptions) {
        setShowMedicineOptions(true);
    }
    
    if (filteredMedicines.length > 0) {
        setSelectedDropdownIndex(prev => {
            const next = prev < filteredMedicines.length - 1 ? prev + 1 : prev;
            // ✅ Auto-advance page if selected item goes beyond current page
            const nextPage = Math.floor(next / MEDICINES_PER_PAGE);
            if (nextPage !== medicinePage) {
                setMedicinePage(nextPage);
            }
            return next;
        });
        
        if (selectedDropdownIndex === -1) {
            setSelectedDropdownIndex(0);
            setMedicinePage(0);
        }
    }
    return;
}

// Arrow Up - Navigate dropdown
if (e.key === 'ArrowUp') {
    e.preventDefault();
    
    if (!showMedicineOptions) {
        setShowMedicineOptions(true);
    }
    
    if (filteredMedicines.length > 0) {
        setSelectedDropdownIndex(prev => {
            const next = prev > 0 ? prev - 1 : 0;
            // ✅ Auto-go to previous page
            const nextPage = Math.floor(next / MEDICINES_PER_PAGE);
            if (nextPage !== medicinePage) {
                setMedicinePage(nextPage);
            }
            return next;
        });
        
        if (selectedDropdownIndex === -1) {
            setSelectedDropdownIndex(filteredMedicines.length - 1);
            setMedicinePage(Math.floor((filteredMedicines.length - 1) / MEDICINES_PER_PAGE));
        }
    }
    return;
}

    // Escape - Close dropdown
    if (e.key === 'Escape') {
        e.preventDefault();
        setShowMedicineOptions(false);
        setSelectedDropdownIndex(-1);
        return;
    }
};

// ✅ HANDLE TAB NAVIGATION IN TABLE
// ✅ HANDLE TAB NAVIGATION IN TABLE
const handleTableKeyDown = (e, rowIndex, fieldName) => {
    // Skip action column completely
    if (fieldName === 'action') {
        e.preventDefault();
        return;
    }

    if (e.key === 'Tab') {
        const currentRow = formData.medicines[rowIndex];
        const fields = ['quantity', 'discount']; // ✅ Removed 'pack' and 'batch'
        const currentFieldIndex = fields.indexOf(fieldName);
        
        if (currentFieldIndex === -1) {
            return;
        }
        
        if (!e.shiftKey) {
            // Forward Tab
            if (currentFieldIndex < fields.length - 1) {
                e.preventDefault();
                const nextField = fields[currentFieldIndex + 1];
                setTimeout(() => {
                    setActiveCell({ rowIndex, cellName: nextField });
                    focusField(rowIndex, nextField);
                }, 0);
            } else {
                // Last field → deactivate and go to medicine search
                e.preventDefault();
                setActiveCell(null);
                setTimeout(() => {
                    if (medicineSearchRef.current) {
                        medicineSearchRef.current.focus();
                    }
                }, 0);
            }
        } else {
            // Backward Tab (Shift+Tab)
            if (currentFieldIndex > 0) {
                e.preventDefault();
                const prevField = fields[currentFieldIndex - 1];
                setTimeout(() => {
                    setActiveCell({ rowIndex, cellName: prevField });
                    focusField(rowIndex, prevField);
                }, 0);
            } else {
                // First field → go to batch select
                e.preventDefault();
                setActiveCell(null);
                setTimeout(() => {
                    const batchSelect = tableRowRefs.current[rowIndex]?.querySelector('select[name^="batch"]');
                    if (batchSelect) {
                        batchSelect.focus();
                    }
                }, 0);
            }
        }
    }

    // ESC → Deactivate current cell
    if (e.key === 'Escape') {
        e.preventDefault();
        setActiveCell(null);
    }
};
// ✅ HANDLE CELL CLICK TO MAKE IT EDITABLE
const handleCellClick = (rowIndex, cellName, e) => {
    // Don't activate if clicking on delete button
    if (e?.target.closest('.text-danger')) {
        return;
    }
    setActiveCell({ rowIndex, cellName });
};

// ✅ CHECK IF A CELL IS ACTIVE
const isCellActive = (rowIndex, cellName) => {
    return activeCell && activeCell.rowIndex === rowIndex && activeCell.cellName === cellName;
};
    // ✅ FOCUS SPECIFIC FIELD
    // ✅ FOCUS SPECIFIC FIELD
const focusField = (rowIndex, fieldName) => {
    if (!tableRowRefs.current[rowIndex]) return;
    
    setTimeout(() => {
        const row = tableRowRefs.current[rowIndex];
        if (!row) return;
        
        let selector;
        switch (fieldName) {
            case 'quantity':
                selector = 'input.product-quantity';
                break;
            case 'discount':
                selector = 'input[name^="med_bill_item_discount"]';
                break;
            default:
                return;
        }
        
        const field = row.querySelector(selector);
        if (field) {
            field.focus();
            // For input fields, select the content for easy editing
            if (field.tagName === 'INPUT') {
                field.select();
            }
        }
    }, 10);
};

    // ✅ CTRL+S TO SAVE
    // ✅ CTRL+S TO SAVE (keep existing one)
useEffect(() => {
    const handleKeyDown = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === 's') {
            e.preventDefault();
            const form = document.querySelector('form');
            if (form) {
                form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
            }
        }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
}, []);

useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
        .swal-on-top {
            z-index: 99999 !important;
        }
        .swal2-container.swal-on-top {
            z-index: 99999 !important;
        }
        .dropdown-item.active {
            background-color: #0d6efd !important;
            color: white !important;
        }
        .dropdown-item:hover {
            background-color: #f8f9fa;
        }
        .dropdown-item.active:hover {
            background-color: #0b5ed7 !important;
        }
        input:focus, select:focus {
            outline: 2px solid #0d6efd;
            outline-offset: 2px;
        }
        
        /* ✅ Enhanced batch select styling */
        select[name^="batch"] option:disabled {
            background-color: #f8f9fa !important;
            color: #6c757d !important;
        }
        select[name^="batch"] option {
            padding: 8px;
            font-size: 13px;
        }
        
        /* ✅ Pack and Batch always appear active */
        select[name^="pack"], select[name^="batch"] {
            border: 1px solid #ced4da;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }
        
        select[name^="pack"]:focus, select[name^="batch"]:focus {
            border-color: #86b7fe;
            box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }
    `;
    document.head.appendChild(style);
    
    return () => {
        document.head.removeChild(style);
    };
}, []);

// ✅ FOCUS ON INPUT WHEN CELL BECOMES ACTIVE
useEffect(() => {
    if (activeCell) {
        const input = document.querySelector(
            `input[name="${activeCell.cellName}${activeCell.rowIndex}"], ` +
            `select[name="${activeCell.cellName}${activeCell.rowIndex}"]`
        );
        if (input) {
            input.focus();
            if (input.tagName === 'INPUT') {
                input.select();
            }
        }
    }
}, [activeCell]);
// ✅ NEW: GLOBAL ENTER KEY TO OPEN MEDICINE SEARCH
useEffect(() => {
    const handleGlobalKeyDown = (e) => {
        // Get currently focused element
        const activeElement = document.activeElement;
        const isInputFocused = activeElement && (
            activeElement.tagName === 'INPUT' || 
            activeElement.tagName === 'TEXTAREA' || 
            activeElement.tagName === 'SELECT' ||
            activeElement.isContentEditable
        );

        // ENTER → OPEN MEDICINE SEARCH (only if no input is focused)
        if (e.key === 'Enter' && !e.ctrlKey && !isInputFocused) {
            e.preventDefault();
            
            // Focus the medicine search input
            if (medicineSearchRef.current) {
                medicineSearchRef.current.focus();
                
                // Open dropdown
                setShowMedicineOptions(true);
                
                // Select first item if available
                if (filteredMedicines.length > 0) {
                    setSelectedDropdownIndex(0);
                }
            }
        }

        // ESC → CLOSE MEDICINE DROPDOWN
        if (e.key === 'Escape') {
            if (showMedicineOptions) {
                e.preventDefault();
                setShowMedicineOptions(false);
                setSelectedDropdownIndex(-1);
            }
        }
    };

    document.addEventListener('keydown', handleGlobalKeyDown);
    return () => document.removeEventListener('keydown', handleGlobalKeyDown);
}, [showMedicineOptions, filteredMedicines.length]);

    // ✅ SCROLL SELECTED ITEM INTO VIEW
    useEffect(() => {
        if (selectedDropdownIndex >= 0 && dropdownRef.current) {
            const dropdown = dropdownRef.current.querySelector('.dropdown-menu');
            if (dropdown) {
                const items = dropdown.querySelectorAll('.dropdown-item');
                if (items[selectedDropdownIndex]) {
                    items[selectedDropdownIndex].scrollIntoView({
                        block: 'nearest',
                        behavior: 'smooth'
                    });
                }
            }
        }
    }, [selectedDropdownIndex]);

    const loadDoctors = async () => {
        try {
            const fd = new FormData();
            fd.append("type", "doctor");
            fd.append("search_key", "");
            fd.append("page_no", "none");
    
            const res = await axios.post(
                AppConst.BASE_URL + AppConst.getUserListUrl,
                fd,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
    
            if (res.data.status) {
                setFormData(prev => ({
                    ...prev,
                    docs: res.data.records || []
                }));
            }
        } catch (err) {
            console.error("Doctor load error", err);
        }
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => {
            const newState = { ...prev, [name]: value };

            if (name === "lab_reg_type") {
                if (value !== originalLabRegType) {
                    setIsUHIDReadOnly(false);
                } else {
                    setIsUHIDReadOnly(true);
                }
            }

            return newState;
        });
    };
 const loadBrokers = async () => {
      try {
        const fd = new FormData();
        fd.append('search_key', '');
        fd.append('page_no', 'none');
        //fd.append('limit', '500');
        const res = await axios.post(
          AppConst.BASE_URL + AppConst.getBrokerListUrl, fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        if (res.data?.status) setBrokers(res.data.records || []);
      } catch (err) { console.error('loadBrokers error', err); }
    };
    const handleChange1 = (e,index) => {
        if (!e || !e.target) return;
        const { name, value } = e.target;
        const name1 = name.replace(/[0-9]/g, "");

        setFormData(prev => {
            const updatedItems = [...prev.medicines];
            updatedItems[index] = {
                ...updatedItems[index],
                [name1]: value
            };
        
            return {
                ...prev,
                medicines: updatedItems
            };
        });
    };
    const attachUserInfo = (fd) => {
        try {
          const stored = sessionStorage.getItem("ldata");
          if (stored) {
            const u = JSON.parse(stored);
            fd.append('user_id',   u.user_id   || '');
            fd.append('user_name', `${u.fname || ''} ${u.lname || ''}`.trim());
            fd.append('user_role', u.role_id   || u.role_name || '');
          }
        } catch (e) {
          console.warn("attachUserInfo failed:", e);
        }
        return fd;
      };

    const formatBillNo = (billId) => {
        if (!billId) return '-';
        return String(billId).padStart(3, '0');
    };

    const fetchConfigData = async () => {
        try {
            const res = await axios.post(
                `${AppConst.BASE_URL + AppConst.getconfig}?config_type=pharmacy`
            );

            if (res.data.status) {
                const data = res.data;
                setImage(data.header_logo);
            }
        }
        catch (err) {
            console.error("Error fetching config:", err);
        }
    };

    const imageUrlToBase64 = async (url) => {
        if (!url) {
            console.error("Image URL is empty or invalid.");
            return null;
        }

        try {
            const response = await fetch(url);
            if (!response.ok) {
                console.error(`Failed to fetch image. Status: ${response.status} ${response.statusText}`);
                return null;
            }

            const blob = await response.blob();

            if (!blob.type.startsWith('image/')) {
                console.error(`The provided URL did not point to an image. It pointed to a file of type: ${blob.type}`);
                return null;
            }

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error fetching or converting image:", error);
            return null;
        }
    };

    const handlePrintInvoice = async () => {
        if (!formData.med_bill_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Save First',
                text: 'Please save the bill before printing',
                confirmButtonColor: '#405189'
            });
            return;
        }

        try {
            let paymentHistory = [];
            try {
                const fd = new FormData();
                fd.append('med_bill_id', formData.med_bill_id);
                
                const historyResponse = await axios.post(
                    AppConst.BASE_URL + AppConst.getMedPaymentHistoryUrl,
                    fd,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );
                
                if (historyResponse.data.status) {
                    paymentHistory = historyResponse.data.records || [];
                }
            } catch (err) {
                console.error("Failed to fetch payment history:", err);
            }

            const invoiceData = {
                items: formData.medicines.filter(m => m.med_bill_item_medicine),
                payment_history: paymentHistory,
                med_bill_id: formData.med_bill_id,
                med_bill_ipd_number: formData.med_bill_ipd_number,
                med_bill_patient_number: formData.med_bill_patient_number,
                med_bill_phone_number: formData.med_bill_phone_number,
                med_bill_doctor: formData.lab_consult_doctor,
                med_bill_ref_doctor: formData.med_bill_ref_doctor,
                med_bill_address_of_patient: formData.med_bill_address_of_patient,
                med_bill_discount_amt: formData.discount_on_all_amt,
                med_bill_total: formData.subtotal,
                med_bill_final_amt: formData.grand_total,
                med_bill_paid: formData.med_bill_paid || '0',
                med_bill_due: formData.med_bill_due || formData.grand_total,
                med_bill_date: formData.med_bill_date,
                med_bill_age_year: formData.lab_reg_age_year,
                med_bill_age_month: formData.lab_reg_age_month,
                med_bill_age_day: formData.lab_reg_age_day,
            };

            generateInvoicePdf(invoiceData);
        } catch (error) {
            console.error("Print error:", error);
            Swal.fire({
                icon: 'error',
                title: 'Print Failed',
                text: 'Failed to generate invoice',
                confirmButtonColor: '#405189'
            });
        }
    };

    const numberToWords = (num) => {
        if (num === null || num === undefined || isNaN(num)) return '';
    
        num = Math.round(Number(num));
    
        const a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ',
            'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ',
            'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    
        const b = ['', '', 'twenty ', 'thirty ', 'forty ', 'fifty ',
            'sixty ', 'seventy ', 'eighty ', 'ninety '];
    
        if (num === 0) return 'Zero Only';
    
        if (num.toString().length > 9) return 'Overflow';
    
        const n = ('000000000' + num)
            .slice(-9)
            .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    
        if (!n) return '';
    
        let str = '';
    
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + a[n[1][1]]) + 'Crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + a[n[2][1]]) + 'Lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + a[n[3][1]]) + 'Thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + a[n[4][1]]) + 'Hundred ' : '';
        str += (n[5] != 0)
            ? ((str !== '') ? 'And ' : '') + (a[Number(n[5])] || b[n[5][0]] + a[n[5][1]])
            : '';
    
        return str.trim()
            .replace(/\s+/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase()) + ' Only';
    };

    const fetchExpiringMedicines = async () => {
        // ── Check last shown time ──
        const TWELVE_HOURS = 12 * 60 * 60 * 1000;
        const lastShown = localStorage.getItem('expiryAlertLastShown');
        const now = Date.now();
    
        if (lastShown && (now - parseInt(lastShown)) < TWELVE_HOURS) {
            // Not 12 hours yet — skip silently
            return;
        }
    
        try {
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getExpiringMedicinesUrl,
                {},
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
    
            if (response.data.status) {
                const medicines = response.data.records || [];
                setExpiringMedicines(medicines);
    
                if (medicines.length > 0) {
                    setShowExpiryAlert(true);
                    // ── Save timestamp so it won't show again for 12 hrs ──
                    localStorage.setItem('expiryAlertLastShown', String(now));
                }
            }
        } catch (error) {
            console.error("Error fetching expiring medicines:", error);
        }
    };
    const formatBillDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
    
        const day = String(d.getDate()).padStart(2, '0');
        const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        const month = monthNames[d.getMonth()];
        const year = d.getFullYear();
    
        return `${day}-${month}-${year}`;
    };
    
    const formatAge = (y = 0, m = 0, d = 0) => {
        const parts = [];
        if (y > 0) parts.push(`${y} Year${y > 1 ? 's' : ''}`);
        if (m > 0) parts.push(`${m} Month${m > 1 ? 's' : ''}`);
        if (d > 0) parts.push(`${d} Day${d > 1 ? 's' : ''}`);
        return parts.length ? parts.join(' ') : '0 Day';
    };
    
    const generateInvoicePdf = async (invoiceData) => {
        const doc = new jsPDF("p", "pt", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 30;
        let y = 40;
    
        const headerImageBase64 = await imageUrlToBase64(image);
        const headerImageHeight = 80;
    
        if (headerImageBase64) {
            doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
        }
    
        y = headerImageHeight + 20;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Pharmacy Bill", pageWidth / 2, y, { align: "center" });
        y += 10;
        doc.rect(margin, y, pageWidth - 2 * margin, 80);
    
        let leftX = margin + 10;
        let rightX = pageWidth / 2 + 40;
        let lineY = y + 15;
    
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Bill To:", leftX, lineY);
    
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
    
        doc.text(
            `Patient Name : ${invoiceData.med_bill_patient_number || 'Walk-in Customer'}`,
            leftX,
            (lineY += 15)
        );
    
        const ageText = formatAge(
            invoiceData.med_bill_age_year,
            invoiceData.med_bill_age_month,
            invoiceData.med_bill_age_day
        );
    
        doc.text(`Age : ${ageText}`, leftX, (lineY += 15));
        doc.text(`Mobile : ${invoiceData.med_bill_phone_number || ''}`, leftX, (lineY += 15));
    
        doc.text(
            `Doctor : ${invoiceData.med_bill_doctor || invoiceData.med_bill_ref_doctor || '-'}`,
            leftX,
            (lineY += 15)
        );
    
        lineY = y + 15;
    
        const grandTotal = parseFloat(invoiceData.med_bill_final_amt || 0);
        const paid = parseFloat(invoiceData.med_bill_paid || 0);
    
        let paymentStatus = "Not Paid";
        if (paid >= grandTotal) paymentStatus = "Paid";
        else if (paid > 0) paymentStatus = "Partial Paid";
    
        doc.text(`UHID : ${invoiceData.med_bill_ipd_number || ''}`, rightX, lineY);
        doc.text(`Bill No : ${formatBillNo(invoiceData.med_bill_id)}`, rightX, (lineY += 15));
        doc.text(`Bill Date : ${formatBillDate(invoiceData.med_bill_date)}`, rightX, (lineY += 15));
        doc.text(`Payment Status : ${paymentStatus}`, rightX, (lineY += 15));
    
        y += 100;
    
        const tableHeaders = [[
            "Sl#", "Product", "Pack", "Qty", "Batch", "Expiry", "HSN", "Discount", "MRP", "Amount"
        ]];
    
        const tableBody = (invoiceData.items || []).map((med, index) => {
            const qty = parseInt(med.med_bill_item_qty || 0);
            const mrp = parseFloat(med.med_bill_item_mrp || 0);
            const discount = parseFloat(med.med_bill_item_discount || 0);
            const total = (mrp - discount) * qty;
    
            return [
                index + 1,
                med.med_bill_item_medicine || '',
                (med.med_bill_item_is_loose == 1 ? "Loose" : "Package"),
                qty,
                med.med_bill_item_batch || '',
                med.med_bill_item_exp || '',
                med.med_bill_item_hsn || '',
                discount.toFixed(2),
                mrp.toFixed(2),
                total.toFixed(2),
            ];
        });
    
        autoTable(doc, {
            startY: y,
            head: tableHeaders,
            body: tableBody,
            theme: "grid",
            styles: { fontSize: 9, cellPadding: 4 },
            headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
        });
    
        y = doc.lastAutoTable.finalY + 15;
    
        if (invoiceData.payment_history && invoiceData.payment_history.length > 0) {
            doc.setFont("helvetica", "bold");
            doc.setFontSize(12);
            doc.text("Payment History", margin, y);
            y += 15;
    
            const paymentHeaders = [["Date & Time", "Mode", "Amount", "Received By"]];
            const paymentBody = invoiceData.payment_history.map(payment => [
                new Date(payment.payment_datetime).toLocaleString(),
                payment.payment_mode,
                `${parseFloat(payment.payment_amount).toFixed(2)}`,
                payment.payment_received_by
            ]);
    
            autoTable(doc, {
                startY: y,
                head: paymentHeaders,
                body: paymentBody,
                theme: "grid",
                styles: { fontSize: 9, cellPadding: 4 },
                headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
            });
    
            y = doc.lastAutoTable.finalY + 15;
        }
    
        const totalTax = (invoiceData.items || []).reduce(
            (sum, i) => sum + parseFloat(i.med_bill_item_tax_amt || 0),
            0
        );
    
        const subtotal = parseFloat(invoiceData.med_bill_total || 0);
        const discountAll = parseFloat(invoiceData.med_bill_discount_amt || 0);
        const due = parseFloat(invoiceData.med_bill_due || 0);
    
        doc.setFontSize(10);
        doc.text(`Subtotal`, pageWidth - margin - 200, y);
        doc.text(`Rs ${subtotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.text(`Total GST`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${totalTax.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.text(`Discount`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${discountAll.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.setFont("helvetica", "bold");
        doc.text(`Grand Total`, pageWidth - margin - 200, (y += 20));
        doc.text(`Rs ${grandTotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.setFont("helvetica", "normal");
        doc.text(`Paid`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${paid.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.text(`Due`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${due.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        y += 30;
        doc.text(`Amount in Words: ${numberToWords(grandTotal)}`, margin, y);
        y += 25;
        doc.setFont("helvetica", "bold");
        doc.text("Authorised Signature", pageWidth - margin, y, { align: "right" });
        
        window.open(doc.output("bloburl"), "_blank");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const fd = new FormData();
    
        fd.append('med_bill_id', formData.med_bill_id);
        fd.append('med_bill_date', formData.med_bill_date);
        fd.append('med_bill_type', formData.lab_reg_type || 'Direct');
        fd.append('lab_reg_age_year', formData.lab_reg_age_year || 0);
        fd.append('lab_reg_age_month', formData.lab_reg_age_month || 0);
        fd.append('lab_reg_age_day', formData.lab_reg_age_day || 0);
    
        fd.append('med_bill_ipd_number', formData.med_bill_ipd_number);
        fd.append('med_bill_patient_number', formData.med_bill_patient_number);
        fd.append('med_bill_doctor', formData.lab_consult_doctor || formData.med_bill_doctor);
        fd.append('med_bill_ref_doctor', formData.med_bill_ref_doctor);
        fd.append('med_bill_phone_number', formData.med_bill_phone_number);
        fd.append('med_bill_address_of_patient', formData.med_bill_address_of_patient);
        fd.append('med_bill_gst_number', formData.med_bill_gst_number);
        fd.append('med_bill_drug_licence_no', formData.med_bill_drug_licence_no);
        fd.append('med_bill_discount', formData.discount_percent || '0');
        fd.append('med_bill_discount_amt', formData.discount_on_all_amt || '0');
        
        fd.append('med_bill_total', formData.subtotal);
        fd.append('med_bill_final_amt', formData.grand_total);

        fd.append('med_bill_broker_id', formData.med_bill_broker_id || '');
fd.append('med_bill_broker_name', formData.med_bill_broker_name || '');
fd.append('med_bill_broker_commission', formData.med_bill_broker_commission || '0');
fd.append('med_bill_broker_commission_type', formData.med_bill_broker_commission_type || 'fixed');
        
        if (formData.med_bill_id && formData.med_bill_id !== '') {
            fd.append('med_bill_paid', formData.med_bill_paid || '0');
            fd.append('med_bill_due', formData.med_bill_due || formData.grand_total);
        } else {
            fd.append('med_bill_paid', '0');
            fd.append('med_bill_due', formData.grand_total);
        }
        
        fd.append('med_bill_remarks', formData.med_bill_remarks || '');
        fd.append('med_items', JSON.stringify(formData.medicines));
        fd.append('med_bill_user', ldata.user_id);
    
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addMedBillUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
    
            if (response.data.status) {
                const billData = response.data.med_bill_dt;
                const generatedUHID = response.data.generated_uhid || billData.med_bill_ipd_number || formData.med_bill_ipd_number;
                
                setFormData(prev => ({
                    ...prev,
                    med_bill_id: billData.med_bill_id,
                    med_bill_paid: billData.med_bill_paid || prev.med_bill_paid || '0',
                    med_bill_due: billData.med_bill_due || prev.med_bill_due || formData.grand_total
                }));
                if (formData.med_bill_id && originalRecord) {
                    try {
                        const logFd = new FormData();
                        logFd.append('record_id', formData.med_bill_id);
                        logFd.append('old_data', JSON.stringify(originalRecord));
                        logFd.append('remarks', 'Pharmacy bill updated');
                        attachUserInfo(logFd);
                        
                        await axios.post(
                            AppConst.BASE_URL + AppConst.logEditMedBillUrl,
                            logFd,
                            { headers: { 'Content-Type': 'multipart/form-data' } }
                        );
                        console.log("✅ Pharmacy bill edit logged");
                    } catch (logErr) {
                        console.warn("⚠️ Audit log failed (non-critical):", logErr);
                    }
                }

                Swal.fire({
                    title: 'Success!',
                    html: `
                        <p><strong>${formData.med_bill_id ? 'Sale Updated' : 'Sale Created'} Successfully!</strong></p>
                        ${generatedUHID ? `<p><strong>UHID:</strong> <span style="color: #0d6efd; font-size: 18px;">${generatedUHID}</span></p>` : ''}
                        <p><strong>Bill No:</strong> ${formatBillNo(billData.med_bill_id)}</p>
                        <p><strong>Due Amount:</strong> <span style="color: #dc3545; font-size: 16px;">₹${parseFloat(billData.med_bill_due || formData.grand_total).toFixed(2)}</span></p>
                    `,
                    icon: 'success',
                    showCancelButton: true,
                    showDenyButton: true,
                    confirmButtonColor: '#198754',
                    denyButtonColor: '#0d6efd',
                    cancelButtonColor: '#6c757d',
                    confirmButtonText: '<i class="ri-hand-coin-line me-1"></i> Make Payment',
                    denyButtonText: '<i class="ri-printer-fill me-1"></i> Print Invoice',
                    cancelButtonText: 'Go to Sales'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        makePayment({
                            ...billData,
                            med_bill_paid: billData.med_bill_paid || formData.med_bill_paid || '0',
                            med_bill_due: billData.med_bill_due || formData.med_bill_due || formData.grand_total
                        });
                    } else if (result.isDenied) {
                        let paymentHistory = [];
                        try {
                            const fd = new FormData();
                            fd.append('med_bill_id', billData.med_bill_id);
                            
                            const historyResponse = await axios.post(
                                AppConst.BASE_URL + AppConst.getMedPaymentHistoryUrl,
                                fd,
                                { headers: { 'Content-Type': 'multipart/form-data' } }
                            );
                            
                            if (historyResponse.data.status) {
                                paymentHistory = historyResponse.data.records || [];
                            }
                        } catch (err) {
                            console.error("Failed to fetch payment history:", err);
                        }
                        
                        const invoiceData = {
                            ...billData,
                            items: formData.medicines.filter(m => m.med_bill_item_medicine),
                            payment_history: paymentHistory,
                            med_bill_id: billData.med_bill_id,
                            med_bill_ipd_number: generatedUHID,
                            med_bill_patient_number: formData.med_bill_patient_number,
                            med_bill_phone_number: formData.med_bill_phone_number,
                            med_bill_doctor: formData.lab_consult_doctor,
                            med_bill_ref_doctor: formData.med_bill_ref_doctor,
                            med_bill_address_of_patient: formData.med_bill_address_of_patient,
                            med_bill_discount_amt: formData.discount_on_all_amt,
                            med_bill_total: formData.subtotal,
                            med_bill_final_amt: formData.grand_total,
                            med_bill_paid: billData.med_bill_paid || formData.med_bill_paid || '0',
                            med_bill_due: billData.med_bill_due || formData.med_bill_due || formData.grand_total,
                            med_bill_date: formData.med_bill_date,
                            med_bill_age_year: formData.lab_reg_age_year,
                            med_bill_age_month: formData.lab_reg_age_month,
                            med_bill_age_day: formData.lab_reg_age_day,
                        };
                        generateInvoicePdf(invoiceData);
                        
                        setTimeout(() => {
                            sessionStorage.removeItem("opd_dt");
                            window.location.href = "/sales";
                        }, 500);
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        sessionStorage.removeItem("opd_dt");
                        window.location.href = "/sales";
                    }
                });
            } else {
                Swal.fire('Error', response.data.success || 'Failed to create sale', 'error');
            }
        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'Failed to create sale', 'error');
        }
    };

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            var fd = new FormData();
            fd.append('page_no', "0");
            fd.append('search_key', formData.search_key + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            tests: records
                        }));
                        if (formData.items.length <= 0) {
                            setFormData(prev => ({
                                ...prev,
                                items: records
                            }));
                        }
                    }
                }
            } catch (error) {

            }

            const fd2 = new FormData();
            fd2.append('type', "doctor");
            fd2.append('search_key', " ");
            fd2.append('page_no', "none");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            docs: records
                        }));
                    }
                }
            } catch (error) {

            }

            fd = new FormData();
            fd.append('cat_type', "vital");
            fd.append('page_no', "none");
            fd.append('search_key', "");
            fd.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            vitals: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };

    const initData3 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (!storedData) {
            console.error("No ldata found in sessionStorage");
            return;
        }
    
        try {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('page_no', "none");
            fd.append('search_key', formData.search_key + "");
            fd.append('purchase_type', "normal");
    
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getPurchaseListUrl, 
                fd,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
    
            if (response.data.status) {
                const records = response.data.records;
                
                if (!records || !Array.isArray(records)) {
                    console.warn("No records found or invalid format");
                    setFormData((prev) => ({
                        ...prev,
                        medicineList: [],
                    }));
                    return;
                }
    
                let allMedicines = [];
    
                records.forEach((rec) => {
                    if (rec.items && Array.isArray(rec.items)) {
                        allMedicines = [...allMedicines, ...rec.items];
                    }
                });
    
                // ✅ DEDUPLICATE by purchase_item_id
                const uniqueMap = {};
                allMedicines.forEach(item => {
                    const id = item.purchase_item_id;
                    if (!uniqueMap[id]) {
                        uniqueMap[id] = item;
                    }
                });
                const uniqueMedicines = Object.values(uniqueMap);
    
                setFormData((prev) => ({
                    ...prev,
                    medicineList: uniqueMedicines, // ✅ Use deduplicated list
                }));
    
            } else {
                console.error("API returned status false:", response.data);
                toast.error(response.data.message || "Failed to load medicines");
                
                setFormData((prev) => ({
                    ...prev,
                    medicineList: [],
                }));
            }
    
        } catch (error) {
            console.error("Error in initData3:", error);
            
            if (error.response) {
                console.error("Server Error Response:", {
                    status: error.response.status,
                    data: error.response.data,
                    headers: error.response.headers
                });
                toast.error(`Server Error: ${error.response.status} - ${error.response.data?.message || 'Unknown error'}`);
            } else if (error.request) {
                console.error("No response received:", error.request);
                toast.error("Network error: No response from server");
            } else {
                console.error("Request setup error:", error.message);
                toast.error(`Error: ${error.message}`);
            }
    
            setFormData((prev) => ({
                ...prev,
                medicineList: [],
            }));
        }
    };

    
    useEffect(() => {
        console.log('🔍 [AUTO-MATCH] useEffect fired', {
            medicineListCount: formData.medicineList?.length || 0,
            medicinesCount: formData.medicines?.length || 0,
        });
    
        console.log('🔬 [AUTO-MATCH] formData.medicines FULL:', JSON.stringify(formData.medicines, null, 2));

        if (!formData.medicineList || formData.medicineList.length === 0) {
            console.log('⏳ [AUTO-MATCH] medicineList not ready');
            return;
        }
    
        const flaggedMeds = formData.medicines.filter(m => m._from_opd_prescription);
        console.log('🏷️ [AUTO-MATCH] flagged meds:', flaggedMeds.map(m => ({
            name: m.med_bill_item_medicine,
            batchesCount: m.available_batches?.length || 0,
            flag: m._from_opd_prescription
        })));
    
        const hasUnmatched = formData.medicines.some(
            m => m._from_opd_prescription && !m.available_batches?.length
        );
        
        console.log('❓ [AUTO-MATCH] hasUnmatched:', hasUnmatched);
        
        if (!hasUnmatched) {
            console.log('✅ [AUTO-MATCH] nothing to match, returning');
            return;
        }
    
        setFormData(prev => {
            const updated = prev.medicines.map(item => {
                if (!item._from_opd_prescription || item.available_batches?.length > 0) {
                    return item;
                }
    
                const nameLower = (item.med_bill_item_medicine || '').toLowerCase().trim();
                if (!nameLower) return item;
    
                console.log(`🔎 [AUTO-MATCH] Searching pharmacy for: "${nameLower}"`);
    
                const matches = prev.medicineList.filter(m => {
                    const stockName = (m.purchase_item_medicine || '').toLowerCase().trim();
                    return stockName === nameLower || 
                           stockName.includes(nameLower) || 
                           nameLower.includes(stockName);
                });
    
                console.log(`📦 [AUTO-MATCH] Found ${matches.length} matches in pharmacy:`, 
                    matches.map(m => ({ 
                        name: m.purchase_item_medicine, 
                        batch: m.purchase_item_batch,
                        pkg: m.purchase_item_qty_stock,
                        loose: m.purchase_item_tab_cap_stock,
                        expM: m.purchase_item_expiry_month,
                        expY: m.purchase_item_expiry_year
                    }))
                );
    
                if (matches.length === 0) {
                    console.log('❌ [AUTO-MATCH] Medicine not found in pharmacy stock');
                    return { ...item, _stock_status: 'not_in_pharmacy' };
                }
    
                // Combine stock across same-batch rows
                const batchMap = {};
                matches.forEach(m => {
                    const key = m.purchase_item_batch || '';
                    if (!batchMap[key]) {
                        batchMap[key] = {
                            ...m,
                            purchase_item_qty_stock: parseInt(m.purchase_item_qty_stock || 0),
                            purchase_item_tab_cap_stock: parseInt(m.purchase_item_tab_cap_stock || 0),
                        };
                    } else {
                        batchMap[key].purchase_item_qty_stock += parseInt(m.purchase_item_qty_stock || 0);
                        batchMap[key].purchase_item_tab_cap_stock += parseInt(m.purchase_item_tab_cap_stock || 0);
                    }
                });
    
                console.log(`📊 [AUTO-MATCH] Combined into ${Object.keys(batchMap).length} unique batches`);
    
                const availableBatches = Object.values(batchMap).filter(batch => {
                    const pkg = parseInt(batch.purchase_item_qty_stock || 0);
                    const loose = parseInt(batch.purchase_item_tab_cap_stock || 0);
                    if (pkg <= 0 && loose <= 0) {
                        console.log(`  ⛔ Batch ${batch.purchase_item_batch}: out of stock`);
                        return false;
                    }
    
                    if (batch.purchase_item_expiry_month && batch.purchase_item_expiry_year) {
                        const today = new Date();
                        const cY = today.getFullYear() % 100;
                        const cM = today.getMonth() + 1;
                        const eY = parseInt(batch.purchase_item_expiry_year, 10);
                        const eM = parseInt(batch.purchase_item_expiry_month, 10);
                        if (eY < cY || (eY === cY && eM < cM)) {
                            console.log(`  ⛔ Batch ${batch.purchase_item_batch}: expired (${eM}/${eY})`);
                            return false;
                        }
                    }
                    console.log(`  ✅ Batch ${batch.purchase_item_batch}: AVAILABLE (pkg:${pkg}, loose:${loose})`);
                    return true;
                });
    
                console.log(`🎯 [AUTO-MATCH] Final available batches: ${availableBatches.length}`);
    
                if (availableBatches.length === 0) {
                    return { ...item, _stock_status: 'out_of_stock' };
                }
    
                const best = availableBatches.sort((a, b) => {
                    const expA = `${a.purchase_item_expiry_year}-${String(a.purchase_item_expiry_month).padStart(2, '0')}`;
                    const expB = `${b.purchase_item_expiry_year}-${String(b.purchase_item_expiry_month).padStart(2, '0')}`;
                    return expB.localeCompare(expA);
                })[0];
    
                const pkgStock = parseInt(best.purchase_item_qty_stock || 0);
                const looseStock = parseInt(best.purchase_item_tab_cap_stock || 0);
                const expMonthName = best.purchase_item_expiry_month
                    ? monthNames[parseInt(best.purchase_item_expiry_month) - 1] : '';
    
                console.log(`🏆 [AUTO-MATCH] Selected best batch: ${best.purchase_item_batch}`);
    
                return {
                    ...item,
                    med_bill_item_batch: best.purchase_item_batch,
                    med_bill_item_hsn: best.purchase_item_hsn || '30049069',
                    med_bill_item_exp: expMonthName ? `${expMonthName}-${best.purchase_item_expiry_year}` : '',
                    purchase_item_expiry_month: best.purchase_item_expiry_month,
                    purchase_item_expiry_year: best.purchase_item_expiry_year,
                    med_bill_item_is_loose: pkgStock > 0 ? '0' : '1',
                    med_bill_item_mrp: pkgStock > 0
                        ? best.purchase_item_mrp
                        : (best.purchase_item_mrp / (parseInt(best.purchase_item_tab_cap) || 15)).toFixed(2),
                    original_mrp: best.purchase_item_mrp,
                    med_bill_item_tax: best.purchase_item_gst || '0',
                    med_bill_item_strips: pkgStock > 0 ? pkgStock : looseStock,
                    package_stock: pkgStock,
                    loose_stock: looseStock,
                    loose_per_package: parseInt(best.purchase_item_tab_cap) || 15,
                    available_batches: availableBatches,
                    _stock_status: 'available'
                };
            });
    
            return { ...prev, medicines: updated };
        });
    }, [
        formData.medicineList,
        formData.medicines.length,
        formData.medicines.map(m => `${m._from_opd_prescription || 0}|${m.med_bill_item_medicine || ''}`).join('§')
    ]);


    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
            initData3();
            fetchConfigData();
            loadDoctors();
            loadBrokers();
            fetchExpiringMedicines();
        }
    
        if (
            sessionStorage.getItem("opd_dt") != null &&
            sessionStorage.getItem("opd_dt") != undefined &&
            sessionStorage.getItem("opd_dt").length > 0
        ) {
            var tmp = JSON.parse(sessionStorage.getItem("opd_dt") + "");
            if (tmp != null && tmp != undefined) {
                setOriginalRecord(tmp);
                const medicines = tmp.items && tmp.items.length > 0 
                    ? tmp.items.map((item, index) => ({
                        sn: index + 1,
                        med_bill_item_medicine: item.med_bill_item_medicine || '',
                        med_bill_item_batch: item.med_bill_item_batch || '',
                        med_bill_item_qty: item.med_bill_item_qty || '1',
                        med_bill_item_strips: item.med_bill_item_strips || '',
                        med_bill_item_is_loose: item.med_bill_item_is_loose || '0',
                        med_bill_item_exp: item.med_bill_item_exp || '',
                        med_bill_item_mrp: item.med_bill_item_mrp || '',
                        med_bill_item_discount: item.med_bill_item_discount || '0',
                        med_bill_item_discount_amt: item.med_bill_item_discount_amt || '0',
                        med_bill_item_tax: item.med_bill_item_tax || '0',
                        med_bill_item_tax_amt: item.med_bill_item_tax_amt || '0',
                        med_bill_item_total: item.med_bill_item_total || '',
                        package_stock: item.med_bill_item_strips || 0,
                        loose_stock: item.med_bill_item_strips || 0,
                        original_mrp: item.med_bill_item_mrp || '',
                        loose_per_package: 0,
                        available_batches: [],
                    }))
                    : [{
                        sn: 1,
                        med_bill_item_medicine: '',
                        med_bill_item_batch: '',
                        med_bill_item_qty: '',
                        med_bill_item_strips: '',
                        med_bill_item_is_loose: '',
                        med_bill_item_exp: '',
                        med_bill_item_mrp: '',
                        med_bill_item_discount: '',
                        med_bill_item_discount_amt: '',
                        med_bill_item_tax: '',
                        med_bill_item_tax_amt: '',
                        med_bill_item_total: '',
                    }];
    
                setFormData(prev => ({
                    ...prev,
                    medicines: medicines,
                    med_bill_id: tmp.med_bill_id || '',
                    med_bill_date: tmp.med_bill_date || '',
                    med_bill_type: tmp.med_bill_type || 'normal',
                    lab_reg_type: tmp.med_bill_type || 'Direct',
                    med_bill_ipd_number: tmp.med_bill_ipd_number || '',
                    med_bill_patient_number: tmp.med_bill_patient_number || '',
                    med_bill_doctor: tmp.med_bill_doctor || '',
                    lab_consult_doctor: tmp.med_bill_doctor || '',
                    med_bill_ref_doctor: tmp.med_bill_ref_doctor || '',
                    med_bill_phone_number: tmp.med_bill_phone_number || '',
                    med_bill_address_of_patient: tmp.med_bill_address_of_patient || '',
                    med_bill_gst_number: tmp.med_bill_gst_number || '',
                    med_bill_drug_licence_no: tmp.med_bill_drug_licence_no || '',
                    discount_percent: tmp.med_bill_discount || '0',
                    discount_on_all_amt: tmp.med_bill_discount_amt || '0',
                    med_bill_mode_of_payment: tmp.med_bill_mode_of_payment || '',
                    subtotal: tmp.med_bill_total || '0',
                    grand_total: tmp.med_bill_final_amt || '0',
                    med_bill_paid: tmp.med_bill_paid || '0',
                    med_bill_payment_mode: tmp.med_bill_payment_mode || 'cash',
                    med_bill_remarks: tmp.med_bill_remarks || '',
                    med_bill_due: tmp.med_bill_due || '0',
                    med_bill_user: tmp.med_bill_user || '',
                    med_bill_datetime: tmp.med_bill_datetime || '',
                    
                    lab_reg_age_year:  tmp.med_bill_age_year  || '',
                    lab_reg_age_month: tmp.med_bill_age_month || '',
                    lab_reg_age_day:   tmp.med_bill_age_day   || '',
                    
                    lab_reg_name_title: tmp.lab_reg_name_title || 'Mr.',
                    lab_reg_gender: tmp.lab_reg_gender || 'Male',
                }));
    
                setOriginalLabRegType(tmp.med_bill_type || 'Direct');
                setIsUHIDReadOnly(true);
            }
        }
    
        return () => {
            console.log('Component unmounted');
        };
    }, []);

    useEffect(() => {
      setFormData(prev => {
        const medicines = prev.medicines.map(item => {
          const mrp = parseFloat(item.med_bill_item_mrp) || 0;
          const qty = parseInt(item.med_bill_item_qty) || 0;
          const discount = parseFloat(item.med_bill_item_discount) || 0;
          const taxRate = parseFloat(item.med_bill_item_tax) || 0;
    
          const base = mrp * qty;
          const afterDiscount = base - discount;
          const taxAmt = (afterDiscount * taxRate) / 100;
          const total = afterDiscount;
    
          return {
            ...item,
            med_bill_item_tax_amt: taxAmt.toFixed(2),
            med_bill_item_total: total.toFixed(2),
          };
        });
    
        return { ...prev, medicines };
      });
    }, [formData.medicines.map(m => (
      `${m.med_bill_item_qty}-${m.med_bill_item_discount}-${m.med_bill_item_tax}-${m.med_bill_item_mrp}`
    )).join('|')]);

    useEffect(() => {
        const stored = sessionStorage.getItem("ldata");
        if (stored) {
            const parsed = JSON.parse(stored);
            setLdata(parsed);
            setPaymentReceivedBy(`${parsed.fname || ''} ${parsed.lname || ''}`.trim());
            
            if (parseInt(parsed.role_id) === 1) {
                setIsAdmin(true);
            } else {
                setIsAdmin(false);
            }
        }
    }, []);



    // ✅ Auto-match prescribed medicines against pharmacy stock when medicineList is ready
useEffect(() => {
    if (!formData.medicineList || formData.medicineList.length === 0) return;

    const hasUnmatched = formData.medicines.some(
        m => m._from_opd_prescription && !m.available_batches?.length
    );
    if (!hasUnmatched) return;

    setFormData(prev => {
        const updated = prev.medicines.map(item => {
            if (!item._from_opd_prescription || item.available_batches?.length > 0) {
                return item;
            }

            // Find matching medicines in pharmacy stock (case-insensitive, partial match)
            const nameLower = (item.med_bill_item_medicine || '').toLowerCase().trim();
            if (!nameLower) return item;

            const matches = prev.medicineList.filter(m => {
                const stockName = (m.purchase_item_medicine || '').toLowerCase().trim();
                return stockName === nameLower || 
                       stockName.includes(nameLower) || 
                       nameLower.includes(stockName);
            });

            if (matches.length === 0) {
                // Not found in pharmacy — mark for UI warning
                return { ...item, _stock_status: 'not_in_pharmacy' };
            }

            // Combine stock across same-batch rows
            const batchMap = {};
            matches.forEach(m => {
                const key = m.purchase_item_batch || '';
                if (!batchMap[key]) {
                    batchMap[key] = {
                        ...m,
                        purchase_item_qty_stock: parseInt(m.purchase_item_qty_stock || 0),
                        purchase_item_tab_cap_stock: parseInt(m.purchase_item_tab_cap_stock || 0),
                    };
                } else {
                    batchMap[key].purchase_item_qty_stock += parseInt(m.purchase_item_qty_stock || 0);
                    batchMap[key].purchase_item_tab_cap_stock += parseInt(m.purchase_item_tab_cap_stock || 0);
                }
            });

            // Filter: not expired, has stock
            const availableBatches = Object.values(batchMap).filter(batch => {
                const pkg = parseInt(batch.purchase_item_qty_stock || 0);
                const loose = parseInt(batch.purchase_item_tab_cap_stock || 0);
                if (pkg <= 0 && loose <= 0) return false;

                // expiry check
                if (batch.purchase_item_expiry_month && batch.purchase_item_expiry_year) {
                    const today = new Date();
                    const cY = today.getFullYear() % 100;
                    const cM = today.getMonth() + 1;
                    const eY = parseInt(batch.purchase_item_expiry_year, 10);
                    const eM = parseInt(batch.purchase_item_expiry_month, 10);
                    if (eY < cY || (eY === cY && eM < cM)) return false;
                }
                return true;
            });

            if (availableBatches.length === 0) {
                return { ...item, _stock_status: 'out_of_stock' };
            }

            // Pick best batch (latest expiry)
            const best = availableBatches.sort((a, b) => {
                const expA = `${a.purchase_item_expiry_year}-${String(a.purchase_item_expiry_month).padStart(2, '0')}`;
                const expB = `${b.purchase_item_expiry_year}-${String(b.purchase_item_expiry_month).padStart(2, '0')}`;
                return expB.localeCompare(expA);
            })[0];

            const pkgStock = parseInt(best.purchase_item_qty_stock || 0);
            const looseStock = parseInt(best.purchase_item_tab_cap_stock || 0);
            const expMonthName = best.purchase_item_expiry_month
                ? monthNames[parseInt(best.purchase_item_expiry_month) - 1] : '';

            return {
                ...item,
                med_bill_item_batch: best.purchase_item_batch,
                med_bill_item_hsn: best.purchase_item_hsn || '30049069',
                med_bill_item_exp: expMonthName ? `${expMonthName}-${best.purchase_item_expiry_year}` : '',
                purchase_item_expiry_month: best.purchase_item_expiry_month,
                purchase_item_expiry_year: best.purchase_item_expiry_year,
                med_bill_item_is_loose: pkgStock > 0 ? '0' : '1',
                med_bill_item_mrp: pkgStock > 0
                    ? best.purchase_item_mrp
                    : (best.purchase_item_mrp / (parseInt(best.purchase_item_tab_cap) || 15)).toFixed(2),
                original_mrp: best.purchase_item_mrp,
                med_bill_item_tax: best.purchase_item_gst || '0',
                med_bill_item_strips: pkgStock > 0 ? pkgStock : looseStock,
                package_stock: pkgStock,
                loose_stock: looseStock,
                loose_per_package: parseInt(best.purchase_item_tab_cap) || 15,
                available_batches: availableBatches,
                _stock_status: 'available'
            };
        });

        return { ...prev, medicines: updated };
    });
}, [formData.medicineList, formData.medicines.length]);


    const fetchPaymentHistory = async (medBillId) => {
        if (!medBillId) return;
        
        try {
            const fd = new FormData();
            fd.append('med_bill_id', medBillId);
            
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getMedPaymentHistoryUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            
            if (response.data.status) {
                setPaymentHistory(response.data.records || []);
            }
        } catch (error) {
            console.error("Error fetching payment history:", error);
        }
    };

    const makePayment = (bill) => {
        try {
            setSelectedPaymentBill(bill);
            setPaymentMode('');
            setPaymentAmount('');
            setPaymentRemarks('');
            fetchPaymentHistory(bill.med_bill_id);
            setShowPaymentModal(true);
        } catch (error) {
            console.error("makePayment error:", error);
        }
    };

    const handleAddPayment = async () => {
        const amount = parseFloat(paymentAmount);
        const due = parseFloat(selectedPaymentBill?.med_bill_due || 0);
        
        if (!paymentMode || paymentMode.trim() === '') {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please select a payment mode',
                confirmButtonColor: '#405189',
                customClass: {
                    container: 'swal-on-top'
                }
            });
            return;
        }
        
        if (!paymentAmount || amount <= 0) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please enter a valid payment amount',
                confirmButtonColor: '#405189',
                customClass: {
                    container: 'swal-on-top'
                }
            });
            return;
        }
        
        if (amount > due) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: `Payment amount cannot exceed due amount (₹${due.toFixed(2)})`,
                confirmButtonColor: '#405189',
                customClass: {
                    container: 'swal-on-top'
                }
            });
            return;
        }
        
        if (!paymentReceivedBy.trim()) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please enter received by name',
                confirmButtonColor: '#405189',
                customClass: {
                    container: 'swal-on-top'
                }
            });
            return;
        }
        
        try {
            const fd = new FormData();
            fd.append('med_bill_id', selectedPaymentBill.med_bill_id);
            fd.append('payment_amount', amount);
            fd.append('payment_mode', paymentMode);
            fd.append('payment_received_by', paymentReceivedBy);
            fd.append('payment_remarks', paymentRemarks);
            fd.append('user_id', ldata?.user_id || '1');
            
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.addMedPaymentUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            
            if (response.data.status) {
                setFormData(prev => ({
                    ...prev,
                    med_bill_paid: response.data.new_paid.toFixed(2),
                    med_bill_due: response.data.new_due.toFixed(2)
                }));
    
                setSelectedPaymentBill(prev => ({
                    ...prev,
                    med_bill_paid: response.data.new_paid,
                    med_bill_due: response.data.new_due
                }));
                
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: response.data.success || 'Payment added successfully',
                    timer: 2000,
                    showConfirmButton: false,
                    customClass: {
                        container: 'swal-on-top'
                    }
                });
                
                setPaymentAmount('');
                setPaymentRemarks('');
                setPaymentMode('');
                
                fetchPaymentHistory(selectedPaymentBill.med_bill_id);
                
                setTimeout(() => {
                    setShowPaymentModal(false);
                }, 2000);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data.success || 'Failed to add payment',
                    confirmButtonColor: '#405189',
                    customClass: {
                        container: 'swal-on-top'
                    }
                });
            }
        } catch (error) {
            console.error("Payment error:", error);
            Swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: 'Failed to add payment. Please try again.',
                confirmButtonColor: '#405189',
                customClass: {
                    container: 'swal-on-top'
                }
            });
        }
    };

    const handleDeletePayment = async (paymentId) => {
        const userRoleId = ldata?.role_id || 0;
        
        if (parseInt(userRoleId) !== 1) {
            Swal.fire({
                icon: 'warning',
                title: 'Permission Denied',
                text: 'Only administrators can delete payments',
                confirmButtonColor: '#405189',
                customClass: {
                    container: 'swal-on-top'
                }
            });
            return;
        }
        
        const result = await Swal.fire({
            title: 'Delete Payment?',
            text: "This will reverse the payment and update the due amount.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            customClass: {
                container: 'swal-on-top'
            }
        });
        
        if (!result.isConfirmed) return;
        
        try {
            const fd = new FormData();
            fd.append('payment_id', paymentId);
            fd.append('user_id', ldata?.user_id || '0');
            attachUserInfo(fd); 
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.deleteMedPaymentUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            
            if (response.data.status) {
                setFormData(prev => ({
                    ...prev,
                    med_bill_paid: response.data.new_paid.toFixed(2),
                    med_bill_due: response.data.new_due.toFixed(2)
                }));
    
                setSelectedPaymentBill(prev => ({
                    ...prev,
                    med_bill_paid: response.data.new_paid,
                    med_bill_due: response.data.new_due
                }));
                
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: response.data.success || 'Payment deleted successfully',
                    timer: 2000,
                    showConfirmButton: false,
                    customClass: {
                        container: 'swal-on-top'
                    }
                });
                
                fetchPaymentHistory(selectedPaymentBill.med_bill_id);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data.success || 'Failed to delete payment',
                    confirmButtonColor: '#405189',
                    customClass: {
                        container: 'swal-on-top'
                    }
                });
            }
        } catch (error) {
            console.error("Delete payment error:", error);
            Swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: 'Failed to delete payment. Please try again.',
                confirmButtonColor: '#405189',
                customClass: {
                    container: 'swal-on-top'
                }
            });
        }
    };

    const handleAutoGenderChange = (e) => {
        const { name, value } = e.target;

        let genderValue = "";

        if (value === "Mr." || value === "Master") {
            genderValue = "Male";
        } else if (value === "Mrs." || value === "Miss") {
            genderValue = "Female";
        } else {
            genderValue = "Other";
        }

        setFormData((prev) => ({
            ...prev,
            lab_reg_name_title: value,
            lab_reg_gender: genderValue
        }));
    };

    useEffect(() => {
        const today = new Date();
        const formatted = today.toISOString().split('T')[0];
        setFormData(prev => ({
            ...prev,
            med_bill_date: formatted
        }));
    }, []);

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            .swal-on-top {
                z-index: 99999 !important;
            }
            .swal2-container.swal-on-top {
                z-index: 99999 !important;
            }
            .dropdown-item.active {
                background-color: #0d6efd !important;
                color: white !important;
            }
            .dropdown-item:hover {
                background-color: #f8f9fa;
            }
            .dropdown-item.active:hover {
                background-color: #0b5ed7 !important;
            }
            input:focus, select:focus {
                outline: 2px solid #0d6efd;
                outline-offset: 2px;
            }
        `;
        document.head.appendChild(style);
        
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const searchUserNow = async () => {

        console.log('🔴🔴🔴 [SEARCH-USER-NOW] FIRED — this is the OLD function!');
        const uhid = (formData.med_bill_ipd_number || "").trim();
    
        if (uhid.length <= 7) {
            toast.error("Please enter a valid UHID");
            return;
        }
    
        try {
            const fd = new FormData();
            fd.append('search_type', formData.lab_reg_type === "Direct" ? "" : formData.lab_reg_type);
    
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.searchUhidUrlCall, 
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
    
            if (response.data.status) {
                const users = response.data.records;
                if (users && users.length > 0) {
                    const patient = users[0];
                    
                    setFormData(prev => ({
                        ...prev,
                        lab_reg_name_title: patient.lab_reg_name_title || "",
                        med_bill_patient_number: patient.lab_reg_name || "",
                        lab_reg_gender: patient.lab_reg_gender || "Male",
                        med_bill_address_of_patient: patient.lab_reg_address || "",
                        lab_reg_city: patient.lab_reg_city || "",
                        lab_reg_state: patient.lab_reg_state || "",
                        med_bill_phone_number: patient.lab_reg_mobile || "",
                        med_bill_type: patient.lab_reg_type || "normal",
                        lab_reg_age_year: patient.lab_reg_age_year || '',
                        lab_reg_age_month: patient.lab_reg_age_month || '',
                        lab_reg_age_day: patient.lab_reg_age_day || '',
                        med_bill_ref_doctor: patient.lab_reg_referral || '',
                        med_bill_ipd_number: patient.lab_reg_uhid || "",
                        lab_reg_type: patient.lab_reg_type || "",
                    }));

                    toast.success("Patient details loaded");
                } else {
                    toast.error("No patient found with this UHID");
                }
            } else {
                toast.error(response.data.message || "No patient found");
            }
        } catch (error) {
            console.error("Search Error:", error);
            toast.error("Error fetching patient details");
        }
    };

    const runPharmaPatientSearch = async (params) => {
        console.log('🟡🟡🟡 [RUN-PHARMA-SEARCH] FIRED with params:', params);
        setPharmaSearchLoading(true);
        try {
            const fd = new FormData();
    
            // ✅ Append search params (UHID / Phone)
            Object.entries(params).forEach(([k, v]) => fd.append(k, v));
    
            // 🔥 IMPORTANT FIX
            const patientType = (formData.lab_reg_type || "").toUpperCase();
    
            if (patientType === "DIRECT") {
                fd.append("search_type", "");   // ✅ allow ALL search
            } else {
                fd.append("search_type", patientType); // OPD / IPD
            }
    
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.searchUhidUrlCall,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
    
            if (!response.data.status) {
                toast.error('No patient found');
                return;
            }
    
            const records = response.data.records || [];
    
            if (records.length === 0) {
                toast.error('No patient found');
                return;
            }
    
            if (records.length === 1) {
                applyPharmaPatient(records[0]);   // ✅ correct
            } else {
                setPharmaPatientResults(records);
                setShowPharmaPatientModal(true);   // ← opens modal
            }
    
        } catch (err) {
            console.error('Pharma search error:', err);
            toast.error('Error searching patient');
        } finally {
            setPharmaSearchLoading(false);
        }
    };
    

// ✅ Smart unified search — auto-detects UHID / Phone / Name
const handlePharmaUnifiedSearch = (val) => {
    console.log('🟢🟢🟢 [UNIFIED-SEARCH] called with:', val);
    setPharmaSearchInput(val);
    const trimmed = val.trim();
  
    if (pharmaSearchDebounceRef.current) clearTimeout(pharmaSearchDebounceRef.current);
  
    if (trimmed.length === 0) {
      setPharmaSuggestions([]);
      return;
    }
  
    const isPhone        = /^[6-9]\d{9}$/.test(trimmed);
    const isPartialPhone = /^\d+$/.test(trimmed);
    const isUhidLike     = /^[A-Za-z]{1,3}\d+/.test(trimmed);
  
    // Phone complete → immediate search
    if (isPhone) {
      pharmaSearchDebounceRef.current = setTimeout(() => {
        runPharmaPatientSearch({ lab_reg_mobile: trimmed });
        setPharmaSuggestions([]);
      }, 300);
      return;
    }
  
    if (isPartialPhone && trimmed.length < 10) {
      setPharmaSuggestions([]);
      return;
    }
  
    // UHID or name → live dropdown
    if (trimmed.length >= 3) {
      pharmaSearchDebounceRef.current = setTimeout(async () => {
        setPharmaSearchLoading(true);
        try {
          const fd = new FormData();
          if (isUhidLike) {
            fd.append('lab_reg_uhid', trimmed);
          } else {
            fd.append('lab_reg_name', trimmed);
          }
  
          // Preserve your existing Direct/OPD/IPD filter
          const patientType = (formData.lab_reg_type || '').toUpperCase();
          if (patientType === 'DIRECT') {
            fd.append('search_type', '');
          } else {
            fd.append('search_type', patientType);
          }
  
          const response = await axios.post(
            AppConst.BASE_URL + AppConst.searchUhidUrlCall,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
          if (response.data.status) {
            setPharmaSuggestions(response.data.records || []);
          } else {
            setPharmaSuggestions([]);
          }
        } catch (err) {
          console.error('Pharma search error:', err);
          setPharmaSuggestions([]);
        } finally {
          setPharmaSearchLoading(false);
        }
      }, 400);
    } else {
      setPharmaSuggestions([]);
    }
  };


  const applyPharmaPatient = (patient) => {
    console.log('🚀 [APPLY-PATIENT] called with patient:', patient.lab_reg_uhid);
    console.log('🚀 [APPLY-PATIENT] prescribed_medicines:', patient.prescribed_medicines);
    
    setFormData(prev => {
        const newState = {
            ...prev,
            lab_reg_name_title:          patient.lab_reg_name_title  || 'Mr.',
            med_bill_patient_number:     patient.lab_reg_name        || '',
            lab_reg_gender:              patient.lab_reg_gender      || 'Male',
            med_bill_address_of_patient: patient.lab_reg_address     || '',
            lab_reg_city:                patient.lab_reg_city        || '',
            lab_reg_state:               patient.lab_reg_state       || '',
            med_bill_phone_number:       patient.lab_reg_mobile      || '',
            lab_reg_age_year:            patient.lab_reg_age_year    || '',
            lab_reg_age_month:           patient.lab_reg_age_month   || '',
            lab_reg_age_day:             patient.lab_reg_age_day     || '',
            med_bill_ref_doctor:         patient.lab_reg_doctor_name || patient.lab_reg_doc || patient.lab_reg_referral || '',
            med_bill_ipd_number:         patient.lab_reg_uhid        || '',
            lab_reg_type:                patient.lab_reg_type        || '',
        };

        const prescribed = patient.prescribed_medicines || [];
        console.log('🚀 [APPLY-PATIENT] prescribed count:', prescribed.length);
        
        if (prescribed.length > 0) {
            newState.medicines = prescribed.map((p, idx) => {
                const med = {
                    sn: idx + 1,
                    med_bill_item_medicine: p.medicine_name || '',
                    med_bill_item_batch: '',
                    med_bill_item_hsn: '',
                    med_bill_item_qty: '',
                    med_bill_item_strips: '',
                    med_bill_item_is_loose: '0',
                    med_bill_item_exp: '',
                    med_bill_item_mrp: '',
                    med_bill_item_discount: '0',
                    med_bill_item_discount_amt: '0',
                    med_bill_item_tax: '0',
                    med_bill_item_tax_amt: '0',
                    med_bill_item_total: '',
                    package_stock: 0,
                    loose_stock: 0,
                    original_mrp: 0,
                    loose_per_package: 15,
                    available_batches: [],
                    _from_opd: true,
                    _from_opd_prescription: true,
                };
                console.log('🚀 [APPLY-PATIENT] created med:', med.med_bill_item_medicine, 'flag:', med._from_opd_prescription);
                return med;
            });
            console.log('🚀 [APPLY-PATIENT] newState.medicines:', newState.medicines);
        }

        return newState;
    });

    setShowPharmaPatientModal(false);
    setPharmaSearchInput('');
    setPharmaSuggestions([]);

    const count = (patient.prescribed_medicines || []).length;
    if (count > 0) {
        toast.success(`Patient loaded with ${count} prescribed medicine${count > 1 ? 's' : ''}. Please select batch & quantity.`, { autoClose: 3500 });
    } else {
        toast.success('Patient details loaded');
    }
};

    const handleBatchChange = (e, index) => {
        const selectedBatchNumber = e.target.value;
        const medicines = [...formData.medicines];
        const currentItem = { ...medicines[index] };
    
        const isBatchUsedElsewhere = formData.medicines.some((item, idx) => 
            idx !== index && 
            item.med_bill_item_medicine === currentItem.med_bill_item_medicine &&
            item.med_bill_item_batch === selectedBatchNumber
        );
    
        if (isBatchUsedElsewhere) {
            Swal.fire({
                icon: "warning",
                title: "Batch Already Used!",
                html: `
                    <p>Batch <strong>${selectedBatchNumber}</strong> is already selected in another row.</p>
                    <p class="text-muted">Please select a different batch.</p>
                `,
                confirmButtonColor: '#ffc107'
            });
            return;
        }
    
        // ✅ Find the batch from available_batches (already combined)
        const newBatchData = currentItem.available_batches.find(
            (b) => b.purchase_item_batch === selectedBatchNumber
        );
    
        // ✅ If not found in available_batches, search from full medicineList and combine
        let finalBatchData = newBatchData;
        if (!finalBatchData) {
            const allMatchingRows = formData.medicineList.filter(
                m => m.purchase_item_medicine === currentItem.med_bill_item_medicine &&
                     m.purchase_item_batch === selectedBatchNumber
            );
    
            if (allMatchingRows.length > 0) {
                finalBatchData = { ...allMatchingRows[0] };
                finalBatchData.purchase_item_qty_stock = 0;
                finalBatchData.purchase_item_tab_cap_stock = 0;
    
                allMatchingRows.forEach(row => {
                    finalBatchData.purchase_item_qty_stock += parseInt(row.purchase_item_qty_stock || 0);
                    finalBatchData.purchase_item_tab_cap_stock += parseInt(row.purchase_item_tab_cap_stock || 0);
                });
            }
        }
    
        if (finalBatchData) {
            const pkgStock = parseInt(finalBatchData.purchase_item_qty_stock || 0);
            const looseStock = parseInt(finalBatchData.purchase_item_tab_cap_stock || 0);
    
            const stockToCheck = currentItem.med_bill_item_is_loose === "1" ? looseStock : pkgStock;
    
            if (stockToCheck <= 0) {
                // ✅ Don't block — check if OTHER stock type is available
                const otherStock = currentItem.med_bill_item_is_loose === "1" ? pkgStock : looseStock;
                if (otherStock <= 0) {
                    Swal.fire({
                        icon: "error",
                        title: "Out of Stock!",
                        text: `Batch ${selectedBatchNumber} is out of stock.`,
                        confirmButtonColor: '#dc3545'
                    });
                    return;
                }
                // ✅ Auto-switch to the available stock type
                Swal.fire({
                    icon: "info",
                    title: "Stock Type Switched",
                    html: currentItem.med_bill_item_is_loose === "1"
                        ? `No loose stock. Switched to <strong>Package</strong> (${pkgStock} available).`
                        : `No package stock. Switched to <strong>Loose</strong> (${looseStock} available).`,
                    timer: 2000,
                    showConfirmButton: false
                });
                currentItem.med_bill_item_is_loose = currentItem.med_bill_item_is_loose === "1" ? "0" : "1";
            }
    
            const expMonthName = finalBatchData.purchase_item_expiry_month
                ? monthNames[parseInt(finalBatchData.purchase_item_expiry_month) - 1]
                : "";
            
            currentItem.med_bill_item_batch = finalBatchData.purchase_item_batch;
            currentItem.med_bill_item_exp = expMonthName
                ? `${expMonthName}-${finalBatchData.purchase_item_expiry_year}`
                : "N/A";
            
            currentItem.purchase_item_expiry_month = finalBatchData.purchase_item_expiry_month;
            currentItem.purchase_item_expiry_year = finalBatchData.purchase_item_expiry_year;
    
            currentItem.med_bill_item_mrp = finalBatchData.purchase_item_mrp;
            currentItem.original_mrp = finalBatchData.purchase_item_mrp;
            
            // ✅ COMBINED stock
            currentItem.package_stock = pkgStock;
            currentItem.loose_stock = looseStock;
            currentItem.loose_per_package = parseInt(finalBatchData.purchase_item_tab_cap) || 15;
            
            // ✅ Set MRP based on current unit type
            if (currentItem.med_bill_item_is_loose === "1") {
                currentItem.med_bill_item_mrp = (finalBatchData.purchase_item_mrp / currentItem.loose_per_package).toFixed(2);
                currentItem.med_bill_item_strips = looseStock;
            } else {
                currentItem.med_bill_item_mrp = finalBatchData.purchase_item_mrp;
                currentItem.med_bill_item_strips = pkgStock;
            }
            
            //currentItem.med_bill_item_qty = '1';
            
            medicines[index] = currentItem;
            setFormData(prev => ({ ...prev, medicines }));
        }
    };

    const isBatchExpired = (expMonth, expYear) => {
        if (!expMonth || !expYear) return false;
    
        const expiryDate = new Date(
            2000 + parseInt(expYear),
            parseInt(expMonth),
            0
        );
    
        const today = new Date();
        today.setHours(0, 0, 0, 0);
    
        return expiryDate < today;
    };
    
    const handleUnitChange = (e, index) => {
        const { value } = e.target;
        const medicines = [...formData.medicines];
        const currentItem = { ...medicines[index] };
    
        // ✅ First, try to use the stock values already on the item
        let totalPkgStock = parseInt(currentItem.package_stock || 0);
        let totalLooseStock = parseInt(currentItem.loose_stock || 0);
    
        // ✅ Re-verify from medicineList using FLEXIBLE name match (same as auto-match)
        const currentNameLower = (currentItem.med_bill_item_medicine || '').toLowerCase().trim();
        const currentBatch = (currentItem.med_bill_item_batch || '').trim();
        
        const allMatchingRows = formData.medicineList.filter(m => {
            const stockName = (m.purchase_item_medicine || '').toLowerCase().trim();
            const stockBatch = (m.purchase_item_batch || '').trim();
            if (stockBatch !== currentBatch) return false;
            return stockName === currentNameLower || 
                   stockName.includes(currentNameLower) || 
                   currentNameLower.includes(stockName);
        });
    
        if (allMatchingRows.length > 0) {
            // Recalculate fresh from medicineList
            let freshPkg = 0;
            let freshLoose = 0;
            allMatchingRows.forEach(row => {
                freshPkg += parseInt(row.purchase_item_qty_stock || 0);
                freshLoose += parseInt(row.purchase_item_tab_cap_stock || 0);
            });
            // Use the larger of the two values (in case item already had stock set)
            totalPkgStock = Math.max(totalPkgStock, freshPkg);
            totalLooseStock = Math.max(totalLooseStock, freshLoose);
        }
    
        // ✅ Update the item's stock with verified values
        currentItem.package_stock = totalPkgStock;
        currentItem.loose_stock = totalLooseStock;
    
        currentItem.med_bill_item_is_loose = value;
        currentItem.med_bill_item_qty = '1';
    
        if (value === "1") {
            // Switching to LOOSE
            if (totalLooseStock <= 0) {
                Swal.fire({
                    icon: "warning",
                    title: "No Loose Stock!",
                    text: `This batch has no loose stock available. Only ${totalPkgStock} packages are available.`,
                    confirmButtonColor: '#ffc107'
                });
                return;
            }
    
            currentItem.med_bill_item_mrp = (currentItem.original_mrp / currentItem.loose_per_package).toFixed(2);
            currentItem.med_bill_item_strips = totalLooseStock;
        } else {
            // Switching to PACKAGE
            if (totalPkgStock <= 0) {
                Swal.fire({
                    icon: "warning",
                    title: "No Package Stock!",
                    text: `This batch has no package stock available. Only ${totalLooseStock} loose units are available.`,
                    confirmButtonColor: '#ffc107'
                });
                return;
            }
    
            currentItem.med_bill_item_mrp = currentItem.original_mrp;
            currentItem.med_bill_item_strips = totalPkgStock;
        }
    
        medicines[index] = currentItem;
        setFormData(prev => ({ ...prev, medicines }));
    };

    const isExpiredBatch = (batch) => {
        if (!batch.purchase_item_expiry_month || !batch.purchase_item_expiry_year) return false;
    
        const today = new Date();
        const currentYear = today.getFullYear() % 100;
        const currentMonth = today.getMonth() + 1;
    
        const expYear = parseInt(batch.purchase_item_expiry_year, 10);
        const expMonth = parseInt(batch.purchase_item_expiry_month, 10);
    
        if (expYear < currentYear) return true;
        if (expYear === currentYear && expMonth < currentMonth) return true;
    
        return false;
    };


    const handleMedicineSelect = (medicine) => {
    const allBatchesForMedicine = formData.medicineList.filter(
        (item) => item.purchase_item_medicine === medicine.purchase_item_medicine
    );

    // ✅ Combine same-batch rows, sum their stock
    const batchMap = {};
    allBatchesForMedicine.forEach(item => {
        const batchKey = (item.purchase_item_batch || '').trim();
        if (!batchMap[batchKey]) {
            batchMap[batchKey] = {
                ...item,
                purchase_item_qty_stock: parseInt(item.purchase_item_qty_stock || 0),
                purchase_item_tab_cap_stock: parseInt(item.purchase_item_tab_cap_stock || 0),
                _source_rows: [item]
            };
        } else {
            batchMap[batchKey].purchase_item_qty_stock += parseInt(item.purchase_item_qty_stock || 0);
            batchMap[batchKey].purchase_item_tab_cap_stock += parseInt(item.purchase_item_tab_cap_stock || 0);
            batchMap[batchKey]._source_rows.push(item);
            
            // ✅ Keep MRP and other details from the row with most stock
            const currentTotal = parseInt(batchMap[batchKey].purchase_item_qty_stock || 0) + 
                                parseInt(batchMap[batchKey].purchase_item_tab_cap_stock || 0);
            const newTotal = parseInt(item.purchase_item_qty_stock || 0) + 
                            parseInt(item.purchase_item_tab_cap_stock || 0);
        }
    });

    const combinedBatches = Object.values(batchMap);

    const usedBatches = formData.medicines
        .filter(item => item.med_bill_item_medicine === medicine.purchase_item_medicine)
        .map(item => item.med_bill_item_batch);

    const availableBatches = combinedBatches.filter(batch => {
        if (usedBatches.includes(batch.purchase_item_batch)) return false;
        if (isExpiredBatch(batch)) return false;
        const pkg = parseInt(batch.purchase_item_qty_stock || 0);
        const loose = parseInt(batch.purchase_item_tab_cap_stock || 0);
        if (pkg <= 0 && loose <= 0) return false;
        return true;
    });
    console.log("=== DEBUG ===");
    console.log("Medicine:", medicine.purchase_item_medicine);
    console.log("allBatchesForMedicine:", allBatchesForMedicine.length);
    console.log("combinedBatches:", combinedBatches);
    console.log("usedBatches:", usedBatches);
    combinedBatches.forEach(batch => {
        console.log("Batch:", batch.purchase_item_batch, {
            expired: isExpiredBatch(batch),
            expMonth: batch.purchase_item_expiry_month,
            expYear: batch.purchase_item_expiry_year,
            pkg: batch.purchase_item_qty_stock,
            loose: batch.purchase_item_tab_cap_stock,
            usedAlready: usedBatches.includes(batch.purchase_item_batch)
        });
    });
    console.log("medicineList total:", formData.medicineList.length);
    console.log("=== END DEBUG ===");



   if (availableBatches.length === 0) {
    // ✅ Check WHY no batches are available
    const allExpired = combinedBatches.length > 0 && combinedBatches.every(batch => isExpiredBatch(batch));
    const allUsed = combinedBatches.length > 0 && combinedBatches.every(batch => usedBatches.includes(batch.purchase_item_batch));
    const allOutOfStock = combinedBatches.length > 0 && combinedBatches.every(batch => {
        const pkg = parseInt(batch.purchase_item_qty_stock || 0);
        const loose = parseInt(batch.purchase_item_tab_cap_stock || 0);
        return pkg <= 0 && loose <= 0;
    });

    let title = "No Available Batches!";
    let message = "";

    if (allExpired) {
        title = "All Batches Expired!";
        const batchDetails = combinedBatches.map(b => {
            const expMonthName = b.purchase_item_expiry_month 
                ? monthNames[parseInt(b.purchase_item_expiry_month) - 1] 
                : "";
            return `<li>Batch: <strong>${b.purchase_item_batch}</strong> — Expired: ${expMonthName}-20${b.purchase_item_expiry_year}</li>`;
        }).join('');
        message = `
            <p><strong>${medicine.purchase_item_medicine}</strong></p>
            <p>All batches for this medicine are <span style="color:#dc3545;font-weight:bold;">EXPIRED</span>.</p>
            <ul style="text-align:left;">${batchDetails}</ul>
            <p class="text-muted">Please purchase new stock.</p>
        `;
    } else if (allOutOfStock) {
        title = "Out of Stock!";
        message = `
            <p><strong>${medicine.purchase_item_medicine}</strong></p>
            <p>All batches are <span style="color:#dc3545;font-weight:bold;">OUT OF STOCK</span>.</p>
            <p class="text-muted">Please purchase new stock.</p>
        `;
    } else if (allUsed) {
        title = "Already Added!";
        message = `
            <p><strong>${medicine.purchase_item_medicine}</strong></p>
            <p>All available batches are already added to this bill.</p>
            <p class="text-muted">Please update the existing row or select a different medicine.</p>
        `;
    } else {
        // Mix of expired + used + out of stock
        const expiredCount = combinedBatches.filter(b => isExpiredBatch(b)).length;
        const usedCount = combinedBatches.filter(b => usedBatches.includes(b.purchase_item_batch)).length;
        const stockOutCount = combinedBatches.filter(b => {
            const pkg = parseInt(b.purchase_item_qty_stock || 0);
            const loose = parseInt(b.purchase_item_tab_cap_stock || 0);
            return pkg <= 0 && loose <= 0;
        }).length;

        message = `
            <p><strong>${medicine.purchase_item_medicine}</strong></p>
            <p>No batches available:</p>
            <ul style="text-align:left;">
                ${expiredCount > 0 ? `<li><span style="color:#dc3545;">${expiredCount} batch(es) EXPIRED</span></li>` : ''}
                ${usedCount > 0 ? `<li>${usedCount} batch(es) already added</li>` : ''}
                ${stockOutCount > 0 ? `<li>${stockOutCount} batch(es) out of stock</li>` : ''}
            </ul>
        `;
    }

    Swal.fire({
        icon: allExpired ? "error" : "warning",
        title: title,
        html: message,
        confirmButtonColor: allExpired ? '#dc3545' : '#ffc107'
    });
    return;
}

    const selectedBatch = availableBatches[0];

    // ✅ Use COMBINED stock values
    const pkgStock = parseInt(selectedBatch.purchase_item_qty_stock || 0);
    const looseStock = parseInt(selectedBatch.purchase_item_tab_cap_stock || 0);

    if (pkgStock <= 0 && looseStock <= 0) {
        Swal.fire({
            icon: "error",
            title: "Out of Stock!",
            text: `Batch ${selectedBatch.purchase_item_batch} is completely out of stock.`,
            confirmButtonColor: '#dc3545'
        });
        return;
    }

    const expMonthName = selectedBatch.purchase_item_expiry_month 
        ? monthNames[parseInt(selectedBatch.purchase_item_expiry_month) - 1] 
        : "";

    const newItem = {
        sn: formData.medicines.length + 1,
        med_bill_item_medicine: selectedBatch.purchase_item_medicine,
        med_bill_item_batch: selectedBatch.purchase_item_batch,
        med_bill_item_hsn: selectedBatch.purchase_item_hsn || '0', 
        med_bill_item_qty: '1',
        med_bill_item_is_loose: pkgStock > 0 ? "0" : "1",
        
        med_bill_item_exp: expMonthName 
            ? `${expMonthName}-${selectedBatch.purchase_item_expiry_year}`
            : "",

        purchase_item_expiry_month: selectedBatch.purchase_item_expiry_month,
        purchase_item_expiry_year: selectedBatch.purchase_item_expiry_year,

        med_bill_item_mrp: pkgStock > 0 
            ? selectedBatch.purchase_item_mrp 
            : (selectedBatch.purchase_item_mrp / (parseInt(selectedBatch.purchase_item_tab_cap) || 15)).toFixed(2),
        med_bill_item_discount: '0',
        med_bill_item_tax: selectedBatch.purchase_item_gst || '0.00',
        med_bill_item_tax_amt: selectedBatch.purchase_item_gst_value || '0.00',
        med_bill_item_total: '',
        
        // ✅ COMBINED stock values
        package_stock: pkgStock,
        loose_stock: looseStock,
        
        med_bill_item_strips: pkgStock > 0 ? pkgStock : looseStock,
        
        available_batches: availableBatches, // ✅ Combined batches
        original_mrp: selectedBatch.purchase_item_mrp,
        loose_per_package: parseInt(selectedBatch.purchase_item_tab_cap) || 15,
    };

    const newRowIndex = formData.medicines.filter(m => m.med_bill_item_medicine).length;

    setFormData((prev) => ({
        ...prev,
        medicines: [...prev.medicines.filter(m => m.med_bill_item_medicine), newItem],
    }));

    setActiveCell({ rowIndex: newRowIndex, cellName: 'pack' });
    setMedicineSearch("");
    setShowMedicineOptions(false);

    toast.success(
        `${selectedBatch.purchase_item_medicine} (Batch: ${selectedBatch.purchase_item_batch}) added`, 
        { autoClose: 2000 }
    );

    if (availableBatches.length === 1) {
        toast.info("This was the last available batch for this medicine", { autoClose: 2000 });
    } else {
        toast.info(`${availableBatches.length - 1} more batch(es) available`, { autoClose: 2000 });
    }

    if (pkgStock <= 0 && looseStock > 0) {
        toast.info("Only loose stock available for this batch", { autoClose: 2000 });
    } else if (looseStock <= 0 && pkgStock > 0) {
        toast.info("Only package stock available for this batch", { autoClose: 2000 });
    }

    setTimeout(() => {
        if (tableRowRefs.current[newRowIndex]) {
            const packSelect = tableRowRefs.current[newRowIndex].querySelector('select[name^="pack"]');
            if (packSelect) packSelect.focus();
        }
    }, 100);
};


    useEffect(() => {
        let subtotal = 0;
        let totalGST = 0;
        let totalDiscount = 0;
        let totalqty = 0;
    
        formData.medicines.forEach((item) => {
            const mrp = parseFloat(item.med_bill_item_mrp) || 0;
            const qty = parseInt(item.med_bill_item_qty) || 0;
            const discount = parseFloat(item.med_bill_item_discount) || 0;
            const taxRate = parseFloat(item.med_bill_item_tax) || 0;
    
            const rowSubtotal = (mrp - discount) * qty;
            const rowTax = (rowSubtotal * taxRate) / 100;
    
            subtotal += rowSubtotal;
            totalDiscount += discount;
            totalGST += rowTax;
            totalqty += qty;
        });
    
        let discountOnAll = 0;
        
        if (discountType === 'percentage') {
            discountOnAll = ((subtotal || 0) * (parseFloat(formData.discount_percent) || 0)) / 100;
        } else {
            discountOnAll = parseFloat(formData.discount_fixed) || 0;
        }
        
        const totalBeforeRounding =
            subtotal +
            (parseFloat(formData.other_charges) || 0) -
            totalDiscount -
            discountOnAll;
    
        let roundOff = 0;
        let grandTotal = totalBeforeRounding;
    
        const decimalPart = totalBeforeRounding - Math.floor(totalBeforeRounding);
    
        if (decimalPart > 0) {
            if (decimalPart > 0.30) {
                roundOff = 1 - decimalPart;
                grandTotal = Math.ceil(totalBeforeRounding);
            } else {
                roundOff = -decimalPart;
                grandTotal = Math.floor(totalBeforeRounding);
            }
        }
    
        setFormData((prev) => ({
            ...prev,
            subtotal: subtotal.toFixed(2),
            total_gst: totalGST.toFixed(2),
            discount_on_all_amt: discountOnAll.toFixed(2),
            round_off: roundOff.toFixed(2),
            grand_total: grandTotal.toFixed(2),
            total_qty: totalqty,
        }));
    }, [formData.medicines, formData.discount_percent, formData.discount_fixed, formData.other_charges, discountType]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowMedicineOptions(false);
                setSelectedDropdownIndex(-1);
            }
        }

        // Only add listener when dropdown is visible
        if (showMedicineOptions) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showMedicineOptions]);

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-12">
                        <div className="card">
                            <div className="card-body">
                                <h5>Pharmacy Sale</h5>
                                <br />
                                <div className="live-preview">
                                    <form onSubmit={handleSubmit}>
                                    <div className="card">
  <div className="card-body">
    <h5 style={{ color: "#405189" }}>Patient Details</h5>
    <br />

    <div className="row align-items-end">

{/* Patient Type */}
<div className="col-md-2">
    <label className="form-label">Patient Type</label>
    <select className="form-control" name="lab_reg_type"
        onChange={handleChange} value={formData.lab_reg_type}>
        <option value="Direct">Direct</option>
        <option value="OPD">OPD</option>
        <option value="IPD">IPD</option>
    </select>
</div>

{/* ✅ Unified Smart Search */}
<div className="col-md-6">
    <label className="form-label">
        Search Patient
        <small className="text-muted ms-2" style={{fontSize:11, fontWeight:400}}>
            (UHID / Phone / Name)
        </small>
    </label>

    <div style={{position:'relative'}}>
        <div className="input-group">
            <span className="input-group-text" style={{background:'#f8f9fa'}}>
                <i className="ri-search-line text-primary"/>
            </span>
            <input
                type="text"
                className="form-control"
                placeholder="Type UHID, 10-digit phone, or patient name..."
                value={pharmaSearchInput}
                onChange={e => handlePharmaUnifiedSearch(e.target.value)}
                autoComplete="off"
            />
            {pharmaSearchLoading && (
                <span className="input-group-text" style={{background:'#fff'}}>
                    <span className="spinner-border spinner-border-sm text-primary"/>
                </span>
            )}
            {pharmaSearchInput && (
                <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => { setPharmaSearchInput(''); setPharmaSuggestions([]); }}
                    title="Clear">
                    <i className="ri-close-line"/>
                </button>
            )}
        </div>

        <small className="text-muted" style={{fontSize:10}}>
            💡 Phone (10 digits) searches instantly. UHID/Name needs 3+ characters.
        </small>

        {/* Unified suggestions dropdown */}
        {pharmaSuggestions.length > 0 && (
            <ul style={{
                position:'absolute',
                top:'100%',
                left:0,
                right:0,
                zIndex:1050,
                maxHeight:280,
                overflowY:'auto',
                border:'1px solid #dee2e6',
                borderRadius:4,
                boxShadow:'0 4px 12px rgba(0,0,0,0.15)',
                margin:'4px 0 0 0',
                padding:0,
                listStyle:'none',
                background:'#fff'
            }}>
                <li style={{
                    padding:'6px 12px',
                    background:'#f8f9fa',
                    borderBottom:'1px solid #dee2e6',
                    fontSize:11,
                    color:'#405189',
                    fontWeight:600
                }}>
                    {pharmaSuggestions.length} match{pharmaSuggestions.length !== 1 ? 'es' : ''} found — click to select
                </li>
                {pharmaSuggestions.map((user, idx) => (
                    <li key={idx}
                        onClick={() => applyPharmaPatient(user)}
                        style={{
                            cursor:'pointer',
                            fontSize:12,
                            padding:'10px 12px',
                            borderBottom:'1px solid #f0f0f0',
                            transition:'background .1s'
                        }}
                        onMouseEnter={e => e.currentTarget.style.background='#f0fff4'}
                        onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                        <div className="d-flex justify-content-between align-items-start">
                            <div style={{flex:1}}>
                                <div>
                                    <strong style={{color:'#405189'}}>
                                        {user.lab_reg_name_title} {user.lab_reg_name}
                                    </strong>
                                </div>
                                <div className="text-muted mt-1" style={{fontSize:11}}>
    <span className="me-2">
        <i className="ri-fingerprint-line me-1"/>
        <strong>{user.lab_reg_uhid}</strong>
    </span>
    <span className="me-2">
        <i className="ri-phone-line me-1"/>
        {user.lab_reg_mobile}
    </span>
    <span className="me-2">
        {user.lab_reg_age_year ? user.lab_reg_age_year+'Y' : ''} / {user.lab_reg_gender}
    </span>
</div>
{user.latest_visit_date && (
    <div className="mt-1" style={{fontSize:11}}>
        <span style={{
            background:'#fff8e1',
            color:'#7c5400',
            padding:'2px 8px',
            borderRadius:'4px',
            fontWeight:600,
            border:'1px solid #ffecb3'
        }}>
            <i className="ri-calendar-event-line me-1"/>
            Last visit: {formatVisitDate(user.latest_visit_date)}
            {user.latest_visit_type && (
                <span style={{marginLeft:4, fontSize:10, opacity:0.8}}>
                    ({user.latest_visit_type})
                </span>
            )}
        </span>
    </div>
)}
                            </div>
                            <div className="d-flex gap-1 ms-2 flex-shrink-0 flex-wrap" style={{maxWidth:120}}>
                                {(user.lab_visit_count > 0) && (
                                    <span className="badge" style={{background:'#cff4fc',color:'#055160',fontSize:9}}>
                                        🧪{user.lab_visit_count}x
                                    </span>
                                )}
                                {(user.ipd_visit_count > 0) && (
                                    <span className="badge" style={{background:'#cfe2ff',color:'#084298',fontSize:9}}>
                                        🏥{user.ipd_visit_count}x
                                    </span>
                                )}
                                {(user.opd_visit_count > 0) && (
                                    <span className="badge" style={{background:'#d1e7dd',color:'#0f5132',fontSize:9}}>
                                        🩺{user.opd_visit_count}x
                                    </span>
                                )}
                                {(user.pharma_visit_count > 0) && (
                                    <span className="badge" style={{background:'#fff3cd',color:'#664d03',fontSize:9}}>
                                        💊{user.pharma_visit_count}x
                                    </span>
                                )}
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        )}
    </div>
</div>

{/* UHID field (read-only display after selection) */}
<div className="col-md-4">
    <label className="form-label">UHID</label>
    <input type="text" className="form-control"
        name="med_bill_ipd_number"
        value={formData.med_bill_ipd_number || ''}
        onChange={handleChange}
        placeholder="Auto-filled from search"
        readOnly/>
</div>

</div>

    {/* ✅ ROW 2 (Patient Name + Age) */}
    <div className="row mt-3">

      {/* Patient Name */}
      <div className="col-md-8">
        <label className="form-label">Patient Name</label>
        <div className="row">
          <div className="col-md-3">
            <select
              className="form-control"
              name="lab_reg_name_title"
              onChange={handleAutoGenderChange}
              value={formData.lab_reg_name_title}
            >
              <option value="Mr.">Mr.</option>
              <option value="Mrs.">Mrs.</option>
              <option value="Miss">Miss</option>
              <option value="Master">Master</option>
            </select>
          </div>

          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              placeholder="Enter Patient Name"
              name="med_bill_patient_number"
              value={formData.med_bill_patient_number}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-3">
            <select className="form-control" value={formData.lab_reg_gender} disabled>
              <option>Male</option>
              <option>Female</option>
            </select>
          </div>
        </div>
      </div>

      {/* Age */}
      <div className="col-md-4">
        <label className="form-label">Age</label>
        <div className="row">
          <div className="col-4">
            <input type="number" className="form-control" placeholder="Y" name="lab_reg_age_year" onChange={handleChange} value={formData.lab_reg_age_year} />
          </div>
          <div className="col-4">
            <input type="number" className="form-control" placeholder="M" name="lab_reg_age_month" onChange={handleChange} value={formData.lab_reg_age_month} />
          </div>
          <div className="col-4">
            <input type="number" className="form-control" placeholder="D" name="lab_reg_age_day" onChange={handleChange} value={formData.lab_reg_age_day} />
          </div>
        </div>
      </div>
    </div>

    {/* ✅ ROW 3 (Address + Mobile + Doctor) */}
    <div className="row mt-3">

      {/* Address */}
      <div className="col-md-6">
        <label className="form-label">Address</label>
        <input
          type="text"
          placeholder="Enter Address"
          className="form-control"
          name="med_bill_address_of_patient"
          value={formData.med_bill_address_of_patient}
          onChange={handleChange}
        />
      </div>

      {/* Mobile + Doctor */}
      <div className="col-md-6">
        <div className="row">
          <div className="col-md-6">
            <label className="form-label">Mobile</label>
            <input
              type="text"
              className="form-control"
              placeholder="Mobile Number"
              name="med_bill_phone_number"
              value={formData.med_bill_phone_number}
              onChange={handleChange}
              maxLength={10}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Doctor</label>
            <Select
              options={formData.docs.map(doc => ({
                value: doc.fname,
                label: doc.fname
              }))}
              value={
                formData.med_bill_ref_doctor
                  ? { value: formData.med_bill_ref_doctor, label: formData.med_bill_ref_doctor }
                  : null
              }
              onChange={(selected) =>
                setFormData(prev => ({
                  ...prev,
                  med_bill_ref_doctor: selected?.value || ""
                }))
              }
              isClearable
            />
          </div>
        </div>
      </div>
    </div>
    <div className="row mt-3">
  <div className="col-md-12">
  <div className="d-flex align-items-center justify-content-between mb-1">
    <label className="form-label">
      <i className="ri-user-shared-line me-1"/>Referral
      {brokerCommission > 0 && (
        <span className="badge bg-success ms-2" style={{fontSize:11}}>
          Commission: ₹{brokerCommission.toFixed(2)}
        </span>
      )}
    </label>




    <button
      type="button"
      className="btn btn-success btn-sm"
      onClick={() => setShowBrokerModal(true)}
    >
      <i className="ri-add-line me-1"/>Add Referral
    </button>
  </div>

    <Select
      options={(brokers || []).map(b => ({
        value: b.id || b.broker_id,
        label: `${b.fname || ''} ${b.lname || ''}`.trim() +
               (b.mobile ? ` (${b.mobile})` : '') +
               (b.pharmacy_commission
                  ? ` — Pharma: ${b.pharmacy_commission_type === 'percentage' ? b.pharmacy_commission + '%' : '₹' + b.pharmacy_commission}`
                  : '')
      }))}
      value={
        formData.med_bill_broker_id
          ? { value: formData.med_bill_broker_id, label: formData.med_bill_broker_name }
          : null
      }
      onChange={(option) => {
        if (!option) { setSelectedBroker(null); return; }
        const b = brokers.find(x => String(x.id || x.broker_id) === String(option.value));
        setSelectedBroker(b || null);
      }}
      placeholder="Select referral / broker..."
      isClearable
    />
    {selectedBroker && (
      <small className="text-muted" style={{fontSize:11}}>
        Pharmacy Commission Type: <strong>{(selectedBroker.pharmacy_commission_type || 'fixed').toUpperCase()}</strong> |
        Rate: <strong>
          {selectedBroker.pharmacy_commission_type === 'percentage'
            ? `${selectedBroker.pharmacy_commission || 0}%`
            : `₹${selectedBroker.pharmacy_commission || 0}`}
        </strong>
      </small>
    )}
  </div>
</div>
  </div>
</div>
                                
                  
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <br/>
                                                <div className="row mb-3">
                                                    <div className="col-2"></div>
                                                    <div className="col-xxl-8 col-sm-8" ref={dropdownRef}>
                                                        <div className="custom-search-box d-flex align-items-center">
                                                            <span className="search-icon-box">
                                                                <i className="ri-barcode-line"></i>
                                                            </span>

                                                            <div style={{ position: "relative", width: "100%" }}>
                                                                <input
                                                                    ref={medicineSearchRef}
                                                                    type="text"
                                                                    className="form-control custom-search-input"
                                                                    placeholder="Item name/Barcode/Itemcode (Press Enter or Click)"
                                                                    value={medicineSearch}
                                                                    onFocus={() => {
                                                                        setShowMedicineOptions(true);
                                                                        if (filteredMedicines.length > 0 && selectedDropdownIndex === -1) {
                                                                            setSelectedDropdownIndex(0);
                                                                        }
                                                                    }}
                                                                    onClick={() => {
                                                                        setShowMedicineOptions(true);
                                                                        if (filteredMedicines.length > 0 && selectedDropdownIndex === -1) {
                                                                            setSelectedDropdownIndex(0);
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        setMedicineSearch(e.target.value);
                                                                        setShowMedicineOptions(true);
                                                                        if (!e.target.value) {
                                                                            setSelectedDropdownIndex(0);
                                                                        }
                                                                    }}
                                                                    onKeyDown={handleMedicineSearchKeyDown}
                                                                />
                                                            </div>
                                                        </div>


                                                        {showMedicineOptions && (
    <div className="dropdown-menu show w-100" style={{ maxHeight: '450px', overflowY: 'auto' }}>
        {(() => {
            const totalResults = filteredMedicines.length;
            const totalPages = Math.ceil(totalResults / MEDICINES_PER_PAGE);
            const startIdx = medicinePage * MEDICINES_PER_PAGE;
            const endIdx = startIdx + MEDICINES_PER_PAGE;
            const pageItems = filteredMedicines.slice(startIdx, endIdx);

            return (
                <>
                    {/* ✅ Results count header */}
                    {totalResults > 0 && (
                        <div style={{
                            padding: '6px 12px',
                            background: '#f1f5fb',
                            fontSize: '12px',
                            color: '#405189',
                            fontWeight: 600,
                            borderBottom: '1px solid #e2e5e8',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <span>
                                {totalResults} medicine{totalResults !== 1 ? 's' : ''} found
                            </span>
                            {totalPages > 1 && (
                                <span style={{ fontSize: '11px', color: '#6c757d' }}>
                                    Page {medicinePage + 1} of {totalPages}
                                </span>
                            )}
                        </div>
                    )}

                    {/* ✅ Medicine items */}
                    {pageItems.length > 0 ? (
                        pageItems.map((m, pageIndex) => {
                            const globalIndex = startIdx + pageIndex;
                            const bestBatch = m.batches
                                .filter(b => {
                                    const pkgStock = parseInt(b.purchase_item_qty_stock || 0);
                                    const looseStock = parseInt(b.purchase_item_tab_cap_stock || 0);
                                    return pkgStock > 0 || looseStock > 0;
                                })
                                .sort((a, b) => {
                                    const expA = `${a.purchase_item_expiry_year}-${String(a.purchase_item_expiry_month).padStart(2, '0')}`;
                                    const expB = `${b.purchase_item_expiry_year}-${String(b.purchase_item_expiry_month).padStart(2, '0')}`;
                                    return expB.localeCompare(expA);
                                })[0];

                            if (!bestBatch) return null;

                            const composition = bestBatch.med_composition || bestBatch.med_comp_name || "";
                            const purpose = bestBatch.purpose_name || m.purpose_name || "";
                            const isSelected = globalIndex === selectedDropdownIndex;
                            // const pkgStock = parseInt(bestBatch.purchase_item_qty_stock || 0);
                            // const looseStock = parseInt(bestBatch.purchase_item_tab_cap_stock || 0);



                            // ✅ Total stock across ALL batches (not just best batch)
const totalPkgStock = m.batches.reduce((sum, b) => sum + parseInt(b.purchase_item_qty_stock || 0), 0);
const totalLooseStock = m.batches.reduce((sum, b) => sum + parseInt(b.purchase_item_tab_cap_stock || 0), 0);
const totalBatches = m.batches.length;

                            // ✅ Match type badge
                            const searchKey = (medicineSearch || '').toLowerCase().trim();
                            let matchType = 'name';
                            if (searchKey) {
                                const nameMatch = (m.purchase_item_medicine || '').toLowerCase().includes(searchKey);
                                const purposeMatch = (purpose || '').toLowerCase().includes(searchKey);
                                const compMatch = (composition || '').toLowerCase().includes(searchKey);

                                if (nameMatch) matchType = 'name';
                                else if (purposeMatch) matchType = 'purpose';
                                else if (compMatch) matchType = 'composition';
                                else matchType = 'composition';
                            }

                            const badgeColors = {
                                name: { bg: '#e8f5e9', color: '#2e7d32', label: 'Name' },
                                composition: { bg: '#fff3e0', color: '#e65100', label: 'Composition' },
                                purpose: { bg: '#e3f2fd', color: '#1565c0', label: 'Purpose' },
                            };
                            const badge = badgeColors[matchType];

                            return (
                                <div
                                    key={globalIndex}
                                    className={`dropdown-item ${isSelected ? 'active' : ''}`}
                                    onClick={() => {
                                        handleMedicineSelect(bestBatch);
                                        setTimeout(() => {
                                            const lastRowIndex = formData.medicines.filter(m => m.med_bill_item_medicine).length - 1;
                                            if (tableRowRefs.current[lastRowIndex]) {
                                                const packSelect = tableRowRefs.current[lastRowIndex].querySelector('select[name^="med_bill_item_is_loose"]');
                                                if (packSelect) packSelect.focus();
                                            }
                                        }, 100);
                                    }}
                                    style={{
                                        cursor: 'pointer',
                                        padding: '10px 12px',
                                        borderBottom: '1px solid #eee',
                                        backgroundColor: isSelected ? '#2d3436' : 'transparent',
color: isSelected ? '#f5f5f5' : 'inherit'
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                        <div style={{ flex: 1 }}>
                                            <div><strong>{m.purchase_item_medicine}</strong></div>

                                            {composition && (
                                                <small className="d-block" style={{ color: isSelected ? '#fff' : '#6c757d' }}>
                                                    Comp: <span style={{ color: isSelected ? '#ffd700' : '#9B870C', fontStyle: 'italic' }}>
                                                        {composition}
                                                    </span>
                                                </small>
                                            )}

                                            {purpose && (
                                                <small className="d-block" style={{ color: isSelected ? '#fff' : '#6c757d' }}>
                                                    Purpose: <span style={{
                                                       color: isSelected ? '#74b9ff' : '#1565c0',
                                                        fontWeight: 600
                                                    }}>
                                                        {purpose}
                                                    </span>
                                                </small>
                                            )}

<small style={{ color: isSelected ? '#fff' : '#6c757d', display: 'block', marginTop: '3px' }}>
    {/* ✅ Total stock across ALL batches */}
    <span style={{ 
        color: isSelected ? '#fff' : '#405189', 
        fontWeight: 700,
        marginRight: '6px'
    }}>
        Total Stock:
    </span>
    <span style={{ 
        color: isSelected ? '#fff' : (totalPkgStock > 0 ? '#198754' : '#dc3545'), 
        fontWeight: 600,
        background: isSelected ? 'rgba(255,255,255,0.25)' : (totalPkgStock > 0 ? '#e8f5e9' : '#fce4ec'),
        padding: '1px 6px',
        borderRadius: '4px',
        marginRight: '4px'
    }}>
        Pkg: {totalPkgStock}
    </span>
    <span style={{ 
        color: isSelected ? '#fff' : (totalLooseStock > 0 ? '#198754' : '#dc3545'), 
        fontWeight: 600,
        background: isSelected ? 'rgba(255,255,255,0.15)' : (totalLooseStock > 0 ? '#e8f5e9' : '#fce4ec'),
        padding: '1px 6px',
        borderRadius: '4px',
        marginRight: '4px'
    }}>
        Loose: {totalLooseStock}
    </span>
    |{' '}
    <span style={{ color: isSelected ? '#e0e0e0' : '#6c757d' }}>
        {totalBatches} batch{totalBatches !== 1 ? 'es' : ''}
    </span>
    |{' '}MRP: <span style={{ color: isSelected ? '#fff' : '#8B4513', fontWeight: 600 }}>
        ₹{bestBatch.purchase_item_mrp}
    </span>
</small>
                                        </div>

                                        {searchKey && (
                                            <span style={{
                                                background: isSelected ? 'rgba(255,255,255,0.2)' : badge.bg,
                                                color: isSelected ? '#fff' : badge.color,
                                                padding: '2px 8px',
                                                borderRadius: '12px',
                                                fontSize: '11px',
                                                fontWeight: 600,
                                                whiteSpace: 'nowrap',
                                                marginLeft: '10px',
                                                alignSelf: 'center'
                                            }}>
                                                {badge.label}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="dropdown-item text-muted text-center py-3">
                            <i className="ri-medicine-bottle-line" style={{ fontSize: '24px', display: 'block', marginBottom: '4px', opacity: 0.4 }}></i>
                            {medicineSearch
                                ? `No medicines found matching "${medicineSearch}"`
                                : 'No medicines available'}
                        </div>
                    )}

                    {/* ✅ PAGINATION: Previous / Next buttons */}
                    {totalPages > 1 && (
                        <div style={{
                            padding: '8px 12px',
                            background: '#f8f9fa',
                            borderTop: '1px solid #e2e5e8',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                disabled={medicinePage === 0}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setMedicinePage(prev => Math.max(0, prev - 1));
                                    setSelectedDropdownIndex((medicinePage - 1) * MEDICINES_PER_PAGE);
                                }}
                                style={{ minWidth: '80px' }}
                            >
                                <i className="ri-arrow-left-s-line"></i> Prev
                            </button>

                            <span style={{ fontSize: '12px', color: '#6c757d' }}>
                                Showing {startIdx + 1}–{Math.min(endIdx, totalResults)} of {totalResults}
                            </span>

                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                disabled={medicinePage >= totalPages - 1}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setMedicinePage(prev => Math.min(totalPages - 1, prev + 1));
                                    setSelectedDropdownIndex((medicinePage + 1) * MEDICINES_PER_PAGE);
                                }}
                                style={{ minWidth: '80px' }}
                            >
                                Next <i className="ri-arrow-right-s-line"></i>
                            </button>
                        </div>
                    )}
                </>
            );
        })()}
    </div>
)}

                                                        
                                                    </div>

                                                    <div className="col-2"></div>
                                                </div>
                                                <br />
                                                <div className="row">
                                                    <div className="col-lg-8">
                                                        <h5 style={{color: "rgb(64 81 137)"}}>Medicines</h5>
                                                    </div>
                                                </div>
                                                <br />
                                            </div>
                                            <div className="col-md-12">
   
                                                <div className="card-body pt-0">
                                                    <div>
                                                        <div className="table-responsive table-card mb-1">
                                                        <table className="table table-nowrap align-middle" id="orderTable" style={{ borderCollapse: 'separate', borderSpacing: '0' }}>
    <thead>
        <tr style={{
            background: 'linear-gradient(135deg, #405189, #5b6abf)',
            color: '#fff',
            fontSize: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
        }}>
            <th style={{ padding: '12px 10px', borderRadius: '8px 0 0 0', width: '50px' }}>#</th>
            <th style={{ padding: '12px 10px' }}>Medicine</th>
            <th style={{ padding: '12px 10px', width: '120px' }}>Pack</th>
            <th style={{ padding: '12px 10px' }}>Batch / Expiry / Stock</th>
            <th style={{ padding: '12px 10px', width: '140px' }}>Quantity</th>
            <th style={{ padding: '12px 10px', width: '110px' }}>MRP (₹)</th>
            <th style={{ padding: '12px 10px', width: '100px' }}>Disc (₹)</th>
            <th style={{ padding: '12px 10px', width: '100px' }}>Tax Amt</th>
            <th style={{ padding: '12px 10px', width: '80px' }}>GST</th>
            <th style={{ padding: '12px 10px', width: '110px' }}>Total (₹)</th>
            <th style={{ padding: '12px 10px', borderRadius: '0 8px 0 0', width: '50px' }}></th>
        </tr>
    </thead>

    <tbody>
        {formData.medicines.filter(m => m.med_bill_item_medicine).length === 0 && (
            <tr>
                <td colSpan="11" style={{ textAlign: 'center', padding: '40px 20px', color: '#adb5bd' }}>
                    <i className="ri-medicine-bottle-line" style={{ fontSize: '40px', display: 'block', marginBottom: '10px', opacity: 0.4 }}></i>
                    <div style={{ fontSize: '15px', fontWeight: 500 }}>No medicines added yet</div>
                    <div style={{ fontSize: '12px', marginTop: '4px' }}>Search and select medicines from the search bar above</div>
                </td>
            </tr>
        )}

        {formData.medicines.map((item, index) => (
            item.med_bill_item_medicine && (
                <tr
                    key={index}
                    ref={el => tableRowRefs.current[index] = el}
                    style={{
                        transition: 'all 0.2s ease',
                        borderLeft: '3px solid transparent',
                        background: index % 2 === 0 ? '#fff' : '#fafbfe',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#f0f4ff';
                        e.currentTarget.style.borderLeft = '3px solid #405189';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = index % 2 === 0 ? '#fff' : '#fafbfe';
                        e.currentTarget.style.borderLeft = '3px solid transparent';
                    }}
                >
                    {/* SN - Colored badge */}
                    <td style={{ padding: '10px' }}>
                        <span style={{
                            background: 'linear-gradient(135deg, #405189, #5b6abf)',
                            color: '#fff',
                            width: '28px',
                            height: '28px',
                            borderRadius: '50%',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '12px',
                            fontWeight: 700
                        }}>
                            {index + 1}
                        </span>
                    </td>

                    {/* Medicine Name with composition */}
                    <td style={{ padding: '10px' }}>
                    <div style={{ fontWeight: 600, fontSize: '14px', color: '#24292f' }}>
    {item.med_bill_item_medicine}
    {item._from_opd && (
        <span className="badge ms-2" style={{
            background:'#e0e7ff', color:'#3730a3',
            fontSize:9, padding:'2px 6px'
        }} title="Added from OPD Prescription">
            Rx
        </span>
    )}
</div>
                        {item.med_bill_item_hsn && item.med_bill_item_hsn !== '0' && (
                            <small style={{ color: '#8B4513', fontSize: '11px' }}>
                                HSN: {item.med_bill_item_hsn}
                            </small>
                        )}
                    </td>

                    {/* PACK */}
                    <td style={{ padding: '10px' }}>
                        <select
                            className="form-control"
                            style={{
                                width: '110px',
                                cursor: 'pointer',
                                fontSize: '13px',
                                fontWeight: 500,
                                background: item.med_bill_item_is_loose === "1"
                                    ? 'linear-gradient(135deg, #fff3e0, #ffe0b2)'
                                    : 'linear-gradient(135deg, #e3f2fd, #bbdefb)',
                                border: item.med_bill_item_is_loose === "1"
                                    ? '1px solid #ffcc80'
                                    : '1px solid #90caf9',
                                color: item.med_bill_item_is_loose === "1" ? '#e65100' : '#1565c0',
                                borderRadius: '6px'
                            }}
                            name={`pack${index}`}
                            value={item.med_bill_item_is_loose}
                            onChange={(e) => handleUnitChange(e, index)}
                            onKeyDown={(e) => {
                                if (e.key === 'Tab' && !e.shiftKey) {
                                    e.preventDefault();
                                    setTimeout(() => {
                                        const batchSelect = tableRowRefs.current[index]?.querySelector('select[name^="batch"]');
                                        if (batchSelect) batchSelect.focus();
                                    }, 0);
                                }
                            }}
                        >
                            <option value="0">📦 Package</option>
                            <option value="1">💊 Loose</option>
                        </select>
                    </td>

                    {/* BATCH */}
                    <td style={{ padding: '10px' }}>
                        {item.available_batches && item.available_batches.length > 1 ? (
                            <div className="position-relative">
                                <select
                                    className="form-control"
                                    style={{
                                        width: '320px',
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        borderRadius: '6px',
                                        border: '1px solid #dee2e6'
                                    }}
                                    name={`batch${index}`}
                                    value={item.med_bill_item_batch}
                                    onChange={(e) => handleBatchChange(e, index)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Tab') {
                                            if (!e.shiftKey) {
                                                e.preventDefault();
                                                setTimeout(() => {
                                                    setActiveCell({ rowIndex: index, cellName: 'quantity' });
                                                    focusField(index, 'quantity');
                                                }, 0);
                                            } else {
                                                e.preventDefault();
                                                setTimeout(() => {
                                                    const packSelect = tableRowRefs.current[index]?.querySelector('select[name^="pack"]');
                                                    if (packSelect) packSelect.focus();
                                                }, 0);
                                            }
                                        }
                                    }}
                                >
                                    <option value="" disabled>-- Select Batch --</option>
                                    {item.available_batches
                                        .filter((batch) => {
                                            const isUsedInOtherRow = formData.medicines.some((med, idx) =>
                                                idx !== index &&
                                                med.med_bill_item_medicine === item.med_bill_item_medicine &&
                                                med.med_bill_item_batch === batch.purchase_item_batch
                                            );
                                            if (isUsedInOtherRow) return false;
                                            if (!batch.purchase_item_expiry_month || !batch.purchase_item_expiry_year) return true;
                                            const today = new Date();
                                            const currentYear = today.getFullYear() % 100;
                                            const currentMonth = today.getMonth() + 1;
                                            const expYear = parseInt(batch.purchase_item_expiry_year, 10);
                                            const expMonth = parseInt(batch.purchase_item_expiry_month, 10);
                                            if (expYear < currentYear) return false;
                                            if (expYear === currentYear && expMonth < currentMonth) return false;
                                            return true;
                                        })
                                        .map((batch, batchIndex) => {
                                            const expMonthName = batch.purchase_item_expiry_month
                                                ? monthNames[parseInt(batch.purchase_item_expiry_month) - 1] : "";
                                            const expDateString = expMonthName && batch.purchase_item_expiry_year
                                                ? `${expMonthName}-${batch.purchase_item_expiry_year}` : "N/A";
                                            const pkgStock = parseInt(batch.purchase_item_qty_stock || 0);
                                            const looseStock = parseInt(batch.purchase_item_tab_cap_stock || 0);
                                            let remainingPkgStock = pkgStock;
                                            let remainingLooseStock = looseStock;
                                            formData.medicines.forEach((med, idx) => {
                                                if (idx !== index && med.med_bill_item_medicine === item.med_bill_item_medicine && med.med_bill_item_batch === batch.purchase_item_batch) {
                                                    const usedQty = parseInt(med.med_bill_item_qty || 0);
                                                    if (med.med_bill_item_is_loose === "1") remainingLooseStock -= usedQty;
                                                    else remainingPkgStock -= usedQty;
                                                }
                                            });
                                            const expired = isBatchExpired(batch.purchase_item_expiry_month, batch.purchase_item_expiry_year);
                                            const isOutOfStock = (remainingPkgStock <= 0 && remainingLooseStock <= 0);
                                            const disabled = expired || isOutOfStock;
                                            let label = `${batch.purchase_item_batch} | Exp: ${expDateString}`;
                                            if (expired) label += " | ⛔ EXPIRED";
                                            else if (isOutOfStock) label += " | ⚠️ OUT OF STOCK";
                                            else label += ` | Pkg: ${remainingPkgStock} | Loose: ${remainingLooseStock}`;
                                            return (
                                                <option key={batchIndex} value={batch.purchase_item_batch} disabled={disabled}
                                                    style={{ color: expired ? '#6c757d' : isOutOfStock ? '#dc3545' : 'inherit', fontWeight: disabled ? 'bold' : 'normal', backgroundColor: disabled ? '#f8f9fa' : 'white' }}>
                                                    {label}
                                                </option>
                                            );
                                        })}
                                </select>
                                <small className="text-muted d-block mt-1" style={{ fontSize: '11px' }}>
                                    {item.available_batches.filter(b => {
                                        const p = parseInt(b.purchase_item_qty_stock || 0);
                                        const l = parseInt(b.purchase_item_tab_cap_stock || 0);
                                        return !isExpiredBatch(b) && (p > 0 || l > 0);
                                    }).length} batch(es) available
                                </small>
                            </div>
                        ) : (
                            <div style={{
                                background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)',
                                padding: '8px 12px',
                                borderRadius: '8px',
                                border: '1px solid #e9ecef',
                                minHeight: '38px'
                            }}
                                tabIndex="0"
                                onKeyDown={(e) => {
                                    if (e.key === 'Tab') {
                                        if (!e.shiftKey) {
                                            e.preventDefault();
                                            setTimeout(() => { setActiveCell({ rowIndex: index, cellName: 'quantity' }); focusField(index, 'quantity'); }, 0);
                                        } else {
                                            e.preventDefault();
                                            setTimeout(() => { const ps = tableRowRefs.current[index]?.querySelector('select[name^="pack"]'); if (ps) ps.focus(); }, 0);
                                        }
                                    }
                                }}
                            >
                                <div style={{ fontSize: '13px', fontWeight: 600, color: '#0d6efd' }}>{item.med_bill_item_batch || 'No Batch'}</div>
                                {item.med_bill_item_batch && (
                                    <>
                                        <div style={{ fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>Exp: {item.med_bill_item_exp || 'N/A'}</div>
                                        <div style={{ fontSize: '11px', marginTop: '2px' }}>
                                            <span style={{ color: '#198754', fontWeight: 600 }}>Pkg: {item.package_stock || 0}</span>
                                            <span style={{ margin: '0 4px', color: '#ccc' }}>|</span>
                                            <span style={{ color: '#e65100', fontWeight: 600 }}>Loose: {item.loose_stock || 0}</span>
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </td>

                    {/* QUANTITY */}
                    <td onClick={(e) => handleCellClick(index, 'quantity', e)} style={{ padding: '10px' }}>
                        <div className="input-step" style={{
                            display: 'flex',
                            alignItems: 'center',
                            border: isCellActive(index, 'quantity') ? '2px solid #405189' : '1px solid #dee2e6',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            transition: 'border 0.2s ease',
                            boxShadow: isCellActive(index, 'quantity') ? '0 0 0 3px rgba(64,81,137,0.15)' : 'none'
                        }}>
                            <button type="button" className="minus"
                                style={{ border: 'none', background: isCellActive(index, 'quantity') ? '#405189' : '#e9ecef', color: isCellActive(index, 'quantity') ? '#fff' : '#6c757d', width: '32px', height: '36px', fontSize: '16px', cursor: 'pointer', transition: 'all 0.2s' }}
                                onClick={(e) => { e.stopPropagation(); if (isCellActive(index, 'quantity')) { let qty = Math.max(1, parseInt(item.med_bill_item_qty || 1) - 1); handleChange1({ target: { name: `med_bill_item_qty${index}`, value: qty } }, index); } }}
                                disabled={!isCellActive(index, 'quantity')}> – </button>
                            <input type="number" className="product-quantity"
                                style={{ width: '50px', textAlign: 'center', border: 'none', outline: 'none', fontSize: '15px', fontWeight: 700, color: '#405189', background: 'transparent' }}
                                name={`quantity${index}`} value={item.med_bill_item_qty} min="1"
                                onChange={(e) => {
                                    const newQty = parseInt(e.target.value) || 1;
                                    let actualStock = item.med_bill_item_is_loose === "0" ? parseInt(item.package_stock || 0) : parseInt(item.loose_stock || 0);
                                    let usedQtyInOtherRows = 0;
                                    formData.medicines.forEach((med, idx) => { if (idx !== index && med.med_bill_item_medicine === item.med_bill_item_medicine && med.med_bill_item_batch === item.med_bill_item_batch && med.med_bill_item_is_loose === item.med_bill_item_is_loose) usedQtyInOtherRows += parseInt(med.med_bill_item_qty || 0); });
                                    const remainingStock = actualStock - usedQtyInOtherRows;
                                    if (newQty > remainingStock) {
                                        Swal.fire({ icon: "warning", title: "Stock Limit!", html: `<p>Max: <strong>${remainingStock}</strong></p>`, timer: 2000 });
                                        handleChange1({ target: { name: `med_bill_item_qty${index}`, value: remainingStock } }, index);
                                    } else handleChange1({ target: { name: `med_bill_item_qty${index}`, value: newQty } }, index);
                                }}
                                onKeyDown={(e) => handleTableKeyDown(e, index, 'quantity')}
                                readOnly={!isCellActive(index, 'quantity')} />
                            <button type="button" className="plus"
                                style={{ border: 'none', background: isCellActive(index, 'quantity') ? '#405189' : '#e9ecef', color: isCellActive(index, 'quantity') ? '#fff' : '#6c757d', width: '32px', height: '36px', fontSize: '16px', cursor: 'pointer', transition: 'all 0.2s' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (isCellActive(index, 'quantity')) {
                                        const currentQty = parseInt(item.med_bill_item_qty);
                                        let actualStock = item.med_bill_item_is_loose === "0" ? parseInt(item.package_stock || 0) : parseInt(item.loose_stock || 0);
                                        let usedQtyInOtherRows = 0;
                                        formData.medicines.forEach((med, idx) => { if (idx !== index && med.med_bill_item_medicine === item.med_bill_item_medicine && med.med_bill_item_batch === item.med_bill_item_batch && med.med_bill_item_is_loose === item.med_bill_item_is_loose) usedQtyInOtherRows += parseInt(med.med_bill_item_qty || 0); });
                                        const remainingStock = actualStock - usedQtyInOtherRows;
                                        if (currentQty >= remainingStock) { Swal.fire({ icon: "warning", title: "Stock Limit!", html: `<p>Max: <strong>${remainingStock}</strong></p>` }); return; }
                                        handleChange1({ target: { name: `med_bill_item_qty${index}`, value: currentQty + 1 } }, index);
                                    }
                                }}
                                disabled={!isCellActive(index, 'quantity')}> + </button>
                        </div>
                    </td>

                    {/* MRP */}
                    <td style={{ padding: '10px' }}>
                        <div style={{ background: '#f8f9fa', padding: '8px 10px', borderRadius: '6px', textAlign: 'right', fontWeight: 600, fontSize: '14px', color: '#2d3436' }}>
                            ₹{item.med_bill_item_mrp}
                        </div>
                    </td>

                    {/* DISCOUNT */}
                    <td onClick={(e) => handleCellClick(index, 'discount', e)} style={{ padding: '10px' }}>
                        <input type="text" className="form-control"
                            style={{
                                width: '80px', textAlign: 'right', borderRadius: '6px', fontSize: '13px', fontWeight: 500,
                                backgroundColor: isCellActive(index, 'discount') ? '#fff' : '#f8f9fa',
                                border: isCellActive(index, 'discount') ? '2px solid #405189' : '1px solid #dee2e6',
                                boxShadow: isCellActive(index, 'discount') ? '0 0 0 3px rgba(64,81,137,0.15)' : 'none',
                                cursor: isCellActive(index, 'discount') ? 'text' : 'pointer'
                            }}
                            name={`discount${index}`} value={item.med_bill_item_discount}
                            onChange={(e) => handleChange1(e, index)}
                            onKeyDown={(e) => handleTableKeyDown(e, index, 'discount')}
                            readOnly={!isCellActive(index, 'discount')} />
                    </td>

                    {/* TAX AMOUNT */}
                    <td style={{ padding: '10px' }}>
                        <div style={{ background: '#f8f9fa', padding: '8px 10px', borderRadius: '6px', textAlign: 'right', fontSize: '13px', color: '#6c757d' }}>
                            {(() => {
                                const mrp = parseFloat(item.med_bill_item_mrp) || 0;
                                const qty = parseInt(item.med_bill_item_qty) || 0;
                                const discount = parseFloat(item.med_bill_item_discount) || 0;
                                const taxRate = parseFloat(item.med_bill_item_tax) || 0;
                                return (((mrp * qty - discount) * taxRate) / 100).toFixed(2);
                            })()}
                        </div>
                    </td>

                    {/* GST */}
                    <td style={{ padding: '10px' }}>
                        <span style={{
                            background: parseFloat(item.med_bill_item_tax) > 0 ? '#e3f2fd' : '#f8f9fa',
                            color: parseFloat(item.med_bill_item_tax) > 0 ? '#1565c0' : '#adb5bd',
                            padding: '4px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: 600
                        }}>
                            {item.med_bill_item_tax}%
                        </span>
                    </td>

                    {/* TOTAL */}
                    <td style={{ padding: '10px' }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #e8f5e9, #c8e6c9)',
                            padding: '8px 10px', borderRadius: '6px', textAlign: 'right',
                            fontWeight: 700, fontSize: '14px', color: '#2e7d32'
                        }}>
                            ₹{(() => {
                                const mrp = parseFloat(item.med_bill_item_mrp) || 0;
                                const qty = parseInt(item.med_bill_item_qty) || 0;
                                const discount = parseFloat(item.med_bill_item_discount) || 0;
                                return (mrp * qty - discount).toFixed(2);
                            })()}
                        </div>
                    </td>

                    {/* DELETE */}
                    <td style={{ padding: '10px', textAlign: 'center' }}>
                        <button type="button" tabIndex="-1"
                            style={{
                                background: 'none', border: '1px solid #fce4ec', borderRadius: '50%',
                                width: '32px', height: '32px', display: 'inline-flex', alignItems: 'center',
                                justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s',
                                color: '#dc3545'
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.background = '#dc3545'; e.currentTarget.style.color = '#fff'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = '#dc3545'; }}
                            onClick={(e) => {
                                e.preventDefault(); e.stopPropagation();
                                const tmp = [...formData.medicines]; tmp.splice(index, 1);
                                setFormData((prev) => ({ ...prev, medicines: tmp }));
                                if (activeCell && activeCell.rowIndex === index) setActiveCell(null);
                                else if (activeCell && activeCell.rowIndex > index) setActiveCell({ ...activeCell, rowIndex: activeCell.rowIndex - 1 });
                            }}
                        >
                            <i className="ri-delete-bin-5-fill fs-16"></i>
                        </button>
                    </td>
                </tr>
            )
        ))}
    </tbody>
</table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
<div className="col-md-8">
    <div className="mt-3">
        <p className="d-flex justify-content-between">
            <span>Total Qty</span>
            <span>
                <input
                    type="number"
                    className="form-control form-control-sm text-end"
                    value={formData.total_qty || 0}
                    readOnly
                />
            </span>
        </p>

        <div className="mb-3">
            <label className="form-label">Discount Type</label>
            <div className="d-flex gap-3">
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="discountType"
                        id="discountPercentage"
                        checked={discountType === 'percentage'}
                        onChange={() => {
                            setDiscountType('percentage');
                            setFormData(prev => ({ ...prev, discount_fixed: '0' }));
                        }}
                    />
                    <label className="form-check-label" htmlFor="discountPercentage">
                        Percentage (%)
                    </label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="discountType"
                        id="discountFixed"
                        checked={discountType === 'fixed'}
                        onChange={() => {
                            setDiscountType('fixed');
                            setFormData(prev => ({ ...prev, discount_percent: '0' }));
                        }}
                    />
                    <label className="form-check-label" htmlFor="discountFixed">
                        Fixed Amount (₹)
                    </label>
                </div>
            </div>
        </div>

        {discountType === 'percentage' ? (
            <p className="d-flex justify-content-between">
                <span>Discount %</span>
                <span>
                    <input
                        type="number"
                        className="form-control form-control-sm text-end"
                        name="discount_percent"
                        value={formData.discount_percent || ""}
                        onChange={(e) => {
                            setFormData((prev) => ({
                                ...prev,
                                discount_percent: e.target.value
                            }));
                        }}
                    />
                </span>
            </p>
        ) : (
            <p className="d-flex justify-content-between">
                <span>Fixed Discount (₹)</span>
                <span>
                    <input
                        type="number"
                        className="form-control form-control-sm text-end"
                        name="discount_fixed"
                        value={formData.discount_fixed || ""}
                        onChange={(e) => {
                            setFormData((prev) => ({
                                ...prev,
                                discount_fixed: e.target.value
                            }));
                        }}
                    />
                </span>
            </p>
        )}

        <div className="mb-3">
            <label className="form-label">Due Amount</label>
            <div className="input-group">
                <input
                    type="text"
                    className="form-control"
                    value={`₹ ${(parseFloat(formData.grand_total || 0) - parseFloat(formData.med_bill_paid || 0)).toFixed(2)}`}
                    readOnly
                    style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold', fontSize: '16px' }}
                />
                <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => {
                        const tempBill = {
                            med_bill_id: formData.med_bill_id || 'NEW',
                            med_bill_patient_number: formData.med_bill_patient_number || 'Walk-in Customer',
                            med_bill_final_amt: formData.grand_total || 0,
                            med_bill_paid: formData.med_bill_paid || 0,
                            med_bill_due: (parseFloat(formData.grand_total || 0) - parseFloat(formData.med_bill_paid || 0)).toFixed(2)
                        };
                        
                        if (!formData.med_bill_id) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Save Bill First',
                                text: 'Please save the bill before making a payment.',
                                confirmButtonColor: '#405189'
                            });
                            return;
                        }
                        
                        makePayment(tempBill);
                    }}
                    disabled={!formData.med_bill_id || parseFloat(formData.grand_total || 0) - parseFloat(formData.med_bill_paid || 0) <= 0}
                >
                    <i className="ri-hand-coin-line me-1"></i> Pay
                </button>
            </div>
            {!formData.med_bill_id && (
                <small className="text-muted">Save the bill first to make payments</small>
            )}
            {formData.med_bill_id && (parseFloat(formData.grand_total || 0) - parseFloat(formData.med_bill_paid || 0) <= 0) && (
                <small className="text-success">✓ Fully Paid</small>
            )}
        </div>

        {formData.med_bill_paid && parseFloat(formData.med_bill_paid) > 0 && (
            <div className="alert alert-success" style={{ fontSize: '14px', padding: '10px' }}>
                <strong>Payment Summary:</strong><br />
                <div className="d-flex justify-content-between mt-1">
                    <span>Total Paid:</span>
                    <strong>₹{parseFloat(formData.med_bill_paid || 0).toFixed(2)}</strong>
                </div>
                <div className="d-flex justify-content-between">
                    <span>Remaining Due:</span>
                    <strong className="text-danger">₹{(parseFloat(formData.grand_total || 0) - parseFloat(formData.med_bill_paid || 0)).toFixed(2)}</strong>
                </div>
            </div>
        )}

        <label>Remarks (Optional)</label>
        <textarea
            className="form-control mb-2"
            name="med_bill_remarks"
            value={formData.med_bill_remarks}
            onChange={handleChange}
            rows="3"
            placeholder="Add any remarks or notes here..."
        />
    </div>
</div>

                                                <div className="col-md-4">
    <div className="card">
        <div className="card-body">
            <p className="d-flex justify-content-between">
                <span>Subtotal</span>
                <span>₹ {formData.subtotal || "0.00"}</span>
            </p>
            <p className="d-flex justify-content-between">
                <span>Other Charges</span>
                <span>₹ {formData.other_charges || "0.00"}</span>
            </p>
            <p className="d-flex justify-content-between">
                <span>Total GST</span>
                <span>₹ {formData.total_gst || "0.00"}</span>
            </p>
            <p className="d-flex justify-content-between text-danger">
                <span>Discount on All</span>
                <span>- ₹ {formData.discount_on_all_amt || "0.00"}</span>
            </p>
            <p className="d-flex justify-content-between" style={{
                color: parseFloat(formData.round_off || 0) >= 0 ? '#198754' : '#dc3545'
            }}>
                <span>Round Off</span>
                <span>
                    {parseFloat(formData.round_off || 0) >= 0 ? '+' : ''} ₹ {formData.round_off || "0.00"}
                </span>
            </p>
            <hr />
            <h5 className="d-flex justify-content-between">
                <span>Grand Total</span>
                <span>₹ {formData.grand_total || "0.00"}</span>
            </h5>
        </div>
    </div>
</div>
                                            </div>
                                        </div>
<div className="row mt-3">
    <div className="col-md-4">
        <button type="submit" className="btn btn-primary w-100">
            <i className="ri-save-line me-1"></i>
            {formData.med_bill_id ? 'Update Bill' : 'Save Bill'}
        </button>
    </div>
    <div className="col-md-4">
        <button 
            type="button" 
            className="btn btn-success w-100"
            onClick={handlePrintInvoice}
            disabled={!formData.med_bill_id}
        >
            <i className="ri-printer-fill me-1"></i>
            Print Invoice
        </button>
    </div>

    <div className="col-md-4">
  <button
    type="button"
    className="btn btn-danger w-100"
    onClick={() => navigate("/sales")}
    
  >
    Close
  </button>
</div>

</div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       
<div className={`modal fade ${showExpiryAlert ? 'show' : ''}`} 
     style={{ display: showExpiryAlert ? 'block' : 'none' }}
     tabIndex="-1">
    <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
            <div className="modal-header bg-warning text-dark">
                <h5 className="modal-title">
                    <i className="ri-alarm-warning-line me-2"></i>
                    Medicines Expiring Soon ({expiringMedicines.length})
                </h5>
                <button 
                    type="button" 
                    className="btn-close" 
                    onClick={() => setShowExpiryAlert(false)}
                ></button>
            </div>
            <div className="modal-body">
                {expiringMedicines.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover">
                            <thead className="table-warning">
                                <tr>
                                    <th>Sl. No.</th>
                                    <th>Medicine Name</th>
                                    <th>Supplier Name</th>
                                    <th>Batch No</th>
                                    <th>Package Qty</th>
                                    <th>Loose Qty</th>
                                    <th>Expiry Date</th>
                                    <th>Days Remaining</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {expiringMedicines.map((medicine, index) => {
                                    let statusClass = '';
                                    let statusText = '';
                                    let badgeClass = '';
                                    
                                    if (medicine.days_remaining <= 7) {
                                        statusClass = 'table-danger';
                                        statusText = 'Critical';
                                        badgeClass = 'badge bg-danger';
                                    } else if (medicine.days_remaining <= 15) {
                                        statusClass = 'table-warning';
                                        statusText = 'Warning';
                                        badgeClass = 'badge bg-warning text-dark';
                                    } else {
                                        statusClass = 'table-info';
                                        statusText = 'Notice';
                                        badgeClass = 'badge bg-info text-dark';
                                    }
                                    
                                    return (
                                        <tr key={index} className={statusClass}>
                                            <td>{index + 1}</td>
                                            <td><strong>{medicine.medicine_name}</strong></td>
                                            <td>{medicine.supplier_name}</td>
                                            <td>
                                                <span className="badge bg-secondary">
                                                    {medicine.batch_no}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                <span className="badge bg-primary">
                                                    {medicine.package_qty}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                <span className="badge bg-success">
                                                    {medicine.loose_qty}
                                                </span>
                                            </td>
                                            <td>{medicine.expiry_date}</td>
                                            <td>
                                                <strong>
                                                    {medicine.days_remaining} day{medicine.days_remaining !== 1 ? 's' : ''}
                                                </strong>
                                            </td>
                                            <td>
                                                <span className={badgeClass}>
                                                    {statusText}
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="text-center py-4">
                        <i className="ri-check-line text-success" style={{ fontSize: '48px' }}></i>
                        <p className="mt-3">No medicines expiring within 30 days</p>
                    </div>
                )}
            </div>
            <div className="modal-footer">
                <button 
                    type="button" 
                    className="btn btn-secondary" 
                    onClick={() => setShowExpiryAlert(false)}
                >
                    Close
                </button>
                <button 
                    type="button" 
                    className="btn btn-primary"
                    onClick={() => {
                        fetchExpiringMedicines();
                        toast.success("Expiry data refreshed");
                    }}
                >
                    <i className="ri-refresh-line me-1"></i> Refresh
                </button>
            </div>
        </div>
    </div>
</div>
{showExpiryAlert && <div className="modal-backdrop fade show"></div>}

      {showPaymentModal && selectedPaymentBill && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add Payment - Bill #{formatBillNo(selectedPaymentBill.med_bill_id)}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowPaymentModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body">
                                <div className="alert alert-info mb-3">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <strong>Patient:</strong> {selectedPaymentBill.med_bill_patient_number}<br />
                                            <strong>Bill No:</strong> {formatBillNo(selectedPaymentBill.med_bill_id)}
                                        </div>
                                        <div className="col-md-6 text-end">
                                            <strong>Total:</strong> ₹{Number(selectedPaymentBill.med_bill_final_amt || 0).toFixed(2)}<br />
                                            <strong>Paid:</strong> ₹{Number(selectedPaymentBill.med_bill_paid || 0).toFixed(2)}<br />
                                            <strong className="text-danger">Due:</strong> ₹{Number(selectedPaymentBill.med_bill_due || 0).toFixed(2)}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Payment Mode *</label>
                                        <select
                                            className="form-control"
                                            value={paymentMode}
                                            onChange={(e) => setPaymentMode(e.target.value)}
                                            style={{ color: paymentMode === '' ? '#999' : '#000' }}
                                        >
                                            <option value="" disabled>-- Select Payment Mode --</option>
                                            <option value="Cash">Cash</option>
                                            <option value="Card">Card</option>
                                            <option value="Online">Online</option>
                                        </select>
                                        {paymentMode === '' && (
                                            <small className="text-danger">Please select a payment mode</small>
                                        )}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Payment Amount *</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter amount"
                                            value={paymentAmount}
                                            onChange={(e) => setPaymentAmount(e.target.value)}
                                            max={selectedPaymentBill.med_bill_due}
                                            step="0.01"
                                        />
                                        <small className="text-muted">
                                            Maximum: ₹{Number(selectedPaymentBill.med_bill_due || 0).toFixed(2)}
                                        </small>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Received By *</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter name"
                                            value={paymentReceivedBy}
                                            readOnly
                                            style={{ backgroundColor: '#e9ecef' }}
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Remarks (Optional)</label>
                                        <textarea
                                            className="form-control"
                                            rows="2"
                                            placeholder="Optional remarks"
                                            value={paymentRemarks}
                                            onChange={(e) => setPaymentRemarks(e.target.value)}
                                        ></textarea>
                                    </div>
                                </div>

                                {paymentHistory.length > 0 && (
                                    <>
                                        <hr />
                                        <h6 className="mb-3">Payment History</h6>
                                        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                            <table className="table table-sm table-bordered">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th style={{width: '40px'}}>Sl.</th>
                                                        <th>Date & Time</th>
                                                        <th>Mode</th>
                                                        <th className="text-end">Amount</th>
                                                        <th>Received By</th>
                                                        {isAdmin && <th style={{width: '80px'}}>Action</th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paymentHistory.map((payment, index) => (
                                                        <tr key={payment.payment_id}>
                                                            <td>{index + 1}</td>
                                                            <td>{new Date(payment.payment_datetime).toLocaleString()}</td>
                                                            <td>
                                                                <span className={`badge ${
                                                                    payment.payment_mode === 'Cash' ? 'bg-success' :
                                                                    payment.payment_mode === 'Card' ? 'bg-primary' :
                                                                    'bg-info'
                                                                }`}>
                                                                    {payment.payment_mode}
                                                                </span>
                                                            </td>
                                                            <td className="text-end">{parseFloat(payment.payment_amount).toFixed(2)}</td>
                                                            <td>{payment.payment_received_by}</td>
                                                            {isAdmin && (
                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => handleDeletePayment(payment.payment_id)}
                                                                    >
                                                                        <i className="ri-delete-bin-line"></i>
                                                                    </button>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot className="table-light">
                                                    <tr>
                                                        <th colSpan="3" className="text-end">Total Paid:</th>
                                                        <th className="text-end">
                                                            ₹{paymentHistory.reduce((sum, p) => sum + parseFloat(p.payment_amount), 0).toFixed(2)}
                                                        </th>
                                                        <th colSpan={isAdmin ? "2" : "1"}></th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowPaymentModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={handleAddPayment}
                                >
                                    <i className="ri-check-line me-1"></i>
                                    Add Payment
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
       
       {/* ── PHARMACY PATIENT SELECTION MODAL ── */}
{showPharmaPatientModal && (
    <div className="modal fade show d-block" tabIndex="-1"
        style={{backgroundColor:'rgba(0,0,0,0.5)', zIndex:10000}}>
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
                <div className="modal-header bg-success text-white">
                    <h5 className="modal-title">
                        <i className="ri-group-line me-2"/>
                        Select Patient — {pharmaPatientResults.length} found
                    </h5>
                    <button type="button" className="btn-close btn-close-white"
                        onClick={() => setShowPharmaPatientModal(false)}/>
                </div>
                <div className="modal-body p-2">
                    {pharmaPatientResults.map((p, idx) => {
                        const age = [
                            p.lab_reg_age_year  ? `${p.lab_reg_age_year}Y`  : '',
                            p.lab_reg_age_month ? `${p.lab_reg_age_month}M` : '',
                            p.lab_reg_age_day   ? `${p.lab_reg_age_day}D`   : '',
                        ].filter(Boolean).join(' ') || 'N/A';
                        const labV    = p.lab_visit_count    ?? 0;
                        const ipdV    = p.ipd_visit_count    ?? 0;
                        const opdV    = p.opd_visit_count    ?? 0;
                        const pharmaV = p.pharma_visit_count ?? 0;
                        return (
                            <div key={idx} className="p-3 mb-2 rounded"
                                style={{border:'1px solid #dee2e6',
                                    cursor:'pointer', background:'#fff',
                                    transition:'background .15s'}}
                                onMouseEnter={e => e.currentTarget.style.background='#f0fff4'}
                                onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                                <div className="d-flex justify-content-between align-items-start">
                                    <div style={{flex:1}}>
                                        <div className="fw-bold fs-6">
                                            {p.lab_reg_name_title} {p.lab_reg_name}
                                        </div>
                                        <div className="text-muted mt-1" style={{fontSize:12}}>
    <span className="me-3">
        <i className="ri-fingerprint-line me-1"/>
        UHID: <strong>{p.lab_reg_uhid}</strong>
    </span>
    <span className="me-3">
        {age} / {p.lab_reg_gender}
    </span>
    <span>
        <i className="ri-phone-line me-1"/>
        {p.lab_reg_mobile}
    </span>
</div>

{p.latest_visit_date && (
    <div className="mt-2">
        <span style={{
            background:'#fff8e1',
            color:'#7c5400',
            padding:'4px 10px',
            borderRadius:'6px',
            fontWeight:600,
            fontSize:12,
            border:'1px solid #ffecb3',
            display:'inline-block'
        }}>
            <i className="ri-calendar-event-line me-1"/>
            Last Visit: <strong>{formatVisitDate(p.latest_visit_date)}</strong>
            {p.latest_visit_type && (
                <span className="ms-2 badge" style={{
                    background:'#fff',
                    color:'#7c5400',
                    border:'1px solid #ffd54f',
                    fontSize:10
                }}>
                    {p.latest_visit_type}
                </span>
            )}
        </span>
    </div>
)}
                                        <div className="mt-2 d-flex gap-2 flex-wrap">
                                            {labV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#cff4fc',color:'#055160',
                                                        fontSize:11,padding:'4px 8px'}}>
                                                    🧪 Lab: {labV}x
                                                </span>
                                            )}
                                            {ipdV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#cfe2ff',color:'#084298',
                                                        fontSize:11,padding:'4px 8px'}}>
                                                    🏥 IPD: {ipdV}x
                                                </span>
                                            )}
                                            {opdV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#d1e7dd',color:'#0f5132',
                                                        fontSize:11,padding:'4px 8px'}}>
                                                    🩺 OPD: {opdV}x
                                                </span>
                                            )}
                                            {pharmaV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#fff3cd',color:'#664d03',
                                                        fontSize:11,padding:'4px 8px'}}>
                                                    💊 Pharma: {pharmaV}x
                                                </span>
                                            )}
                                            {(labV+ipdV+opdV+pharmaV) === 0 && (
                                                <span className="badge bg-secondary"
                                                    style={{fontSize:11}}>New Patient</span>
                                            )}
                                        </div>
                                    </div>
                                    <button type="button"
                                        className="btn btn-sm btn-success ms-3"
                                        onClick={() => applyPharmaPatient(p)}>
                                        <i className="ri-check-line me-1"/>Select
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary"
                        onClick={() => setShowPharmaPatientModal(false)}>Cancel</button>
                </div>
            </div>
        </div>
    </div>
)}


<NewBroker
  item={null}
  show={showBrokerModal}
  onClose={(refresh) => {
    setShowBrokerModal(false);
    if (refresh) {
      loadBrokers(''); // or whatever your broker reload function is named
    }
  }}
/>
        </div>
    );
}

export default AddSale2;